import React, { useState, useEffect,useRef } from "react";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import AWS from '../../aws-mock';
import { fetchAuthSession,updateUserAttributes,signOut  } from 'aws-amplify/auth';
import Editor from '@monaco-editor/react';
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader, 
  CCol,
  CTable,
  CTableHead, 
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CFormSelect, 
  CModal,
  CModalHeader,
  CModalTitle,
  CAlertHeading,
  CAlert,
  CModalBody,
  CModalFooter,
  CFormInput,
  CFormCheck,
  CProgress,
  CProgressBar,
  CSpinner,
  CToast,
  CToastHeader,
  CToastBody,
  CToaster,
  CCollapse
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import {cilReload,cilCaretBottom,cilPen,cifCo, cifUs, cifCr, cifAr,cifMx,cifEs,cifBr,cifVe,cifRu,cilLockUnlocked, cibMixcloud} from '@coreui/icons';
import Button from 'react-bootstrap/Button';

function Dashboard() {
 
  const S3_BUCKET ='www.codeflex.lat';
  const REGION ='us-east-1';
  AWS.config.update({
      accessKeyId: process.env.REACT_APP_ACCESSKEYID,
      secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY
  })

  const myBucket = new AWS.S3({
    apiVersion: process.env.REACT_APP_REGION,
    params: { Bucket: S3_BUCKET},
    region: REGION,
    httpOptions: {
      timeout: 86400000 // valor en milisegundos (24 hora)
    }
  })   

  const DYNAMODB_TABLE_NAME = 'codeflex'; 
  const DYNAMODB_TABLE_WIDGETS = 'Widgets'; 

  const dynamodb = new AWS.DynamoDB.DocumentClient({
    region: REGION,
    credentials: new AWS.Credentials({
      accessKeyId: process.env.REACT_APP_ACCESSKEYID,
      secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY
    }),
  });
  const [profile, setprofile] = useState()
  const [sub, setUser] = useState()
  const [datos,SetDatos] = useState([]);
  const [datos2,SetDatos2] = useState([]);
  const [datos3,SetDatos3] = useState([]);
  const [cargandoTabla, setCargandoTabla] = useState(true);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);
  const [extension, setExtension] = useState("");
  const [extension2, setExtension2] = useState("");
  const [base,SetDB] = useState();
  const [extension3, setExtension3] = useState("Todos los archivos");
  const [carpetas, setcarpetas] = useState("");
  const [visible, setVisible] = useState(false)
  const [visible2, setVisible2] = useState(false)
  const [visible3, setVisible3] = useState(false)
  const [visible4, setVisible4] = useState(false)
  const [visible6, setVisible6] = useState(false)
  const [Archivo, setArchivo] = useState()
  const [Input, setInput] = useState("")
  const [Input2, setInput2] = useState("")
  const [searchInput, setSearchInput] = useState("");
  const [totalSize, setTotalSize] = useState(0);
  const [Activardoc, setActivardoc] = useState(false)
  const [Activardoc2, setActivardoc2] = useState(false)
  const [premium2, setpremium] = useState()
  const [nombre, setnombre] = useState()
  const [email, setEmail] = useState()
  const [usuario, setusuario] = useState()
  const [tel, settel] = useState()
  const [mfa, setmfa] = useState()
  const [numeroSubcarpeta, setNumeroSubcarpeta] = useState(2);



  useEffect(() => {
    (async () => {
      try {
        await fetchAuthSession().then(data => 
        {
          leerWidgets();
          setprofile(data.tokens.idToken.payload.profile);
          leerptoyectos(data.tokens.accessToken.payload.username);
          loadLEGALES2(data.tokens.accessToken.payload.sub);
          loadLEGALES(data.tokens.accessToken.payload.sub);
          setEmail(data.tokens.idToken.payload.email);
          setmfa(data.tokens.idToken.payload.preferred_username);
          setnombre(data.tokens.idToken.payload.name);
          settel(data.tokens.idToken.payload.phone_number);
          setusuario(data.tokens.accessToken.payload.username);
          setUser(data.tokens.accessToken.payload.sub);
          setpremium(data.tokens.idToken.payload.website);
          if(data.tokens.idToken.payload.website === "true"){
            setVisiblee(false)
          }else{
            setVisiblee(true)
            async function leerProyectos2() {
              let valid;
              const params = {
                TableName: "codeflex",
                ProjectionExpression: "email",
              };
             
              try {
                const data = await dynamodb.scan(params).promise();
                let emailEncontrado = false;
            
                if (data.Items && data.Items.length > 0) {
                  data.Items.forEach(item => {
                  const emaill = item.email.toLowerCase().trim();
                  const emailToCompare = email.toLowerCase().trim();

                  if (emaill === emailToCompare) {
                    emailEncontrado = true;
                  }

                  });
            
                  if (emailEncontrado) {
                    valid = "true";
                  } else {
                    valid = "false";
                  }
                } else {
                  console.log('No se encontraron proyectos.');
                }
              } catch (err) {
                console.error('Error al buscar proyecto:', err);
              }
              SetRepetir(valid);
            }
            leerProyectos2();
          }

        });

      } catch (err) {
        console.log(err);
      }

    })();	
	},[]);


  //nuevo
  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };
  
  const sortData = (data) => {
    if (!sortColumn) return data;
  
    const sortedData = [...data].sort((a, b) => {
      if (sortColumn === 'tamano') {
        // Mantenemos la lógica para 'tamano' sin cambios
        const parseSize = (sizeStr) => {
          const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
          const regex = /([\d.]+)\s*([a-zA-Z]+)/;
          const match = sizeStr.match(regex);
  
          if (!match) return 0;
  
          const value = parseFloat(match[1]);
          const unit = match[2];
  
          const index = sizes.indexOf(unit);
          if (index === -1) return 0;
  
          return value * Math.pow(1024, index);
        };
  
        const aVal = parseSize(a[sortColumn]);
        const bVal = parseSize(b[sortColumn]);
  
        return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
      }
  
      if (sortColumn === 'fecha') {
        // Función para convertir fechas al formato correcto
        const parseDate = (dateStr) => {
          if (!dateStr || dateStr === '-') return null; // Ignorar "-" o valores vacíos
          const [day, month, yearTime] = dateStr.split('/');
          const [year, time] = yearTime.split(', ');
          return new Date(`${year}-${month}-${day} ${time}`);
        };
  
        const aVal = parseDate(a[sortColumn]);
        const bVal = parseDate(b[sortColumn]);
  
        // Manejo de casos especiales
        if (!aVal && !bVal) return 0; // Ambas son inválidas, no hay diferencia
        if (!aVal) return 1; // a es inválido ("-" o vacío), debe ir después
        if (!bVal) return -1; // b es inválido ("-" o vacío), debe ir después
  
        // Comparación de fechas
        return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
      }
    });
  
    return sortedData;
  };
  //
  const [URL, setURL] = useState('');
  const [NOMBRE, setNOMBRE] = useState('');
  const [NOMBRE2, setNOMBRE2] = useState('');
  const [EXTENSION, setEXTENSION] = useState('');
  const [TAMAñO, setTAMAñO] = useState('');
  const [FECHA, setFECHA] = useState('');
  const [Imagenes, setImagenes] = useState('');
  const [currentFolder, setCurrentFolder] =  useState([]);
  const [btn, setbtn] = useState(false)
  const [Activado, setActivado] = useState(false)
  const [ssub, setSsub] = useState(''); // Estado para ssub
  const [carpe, setCarpe] = useState(''); // Estado para carpe


  const russianDomains = [
    "msu.ru", 
    "spbu.ru", 
    "misis.ru", 
    "mipt.ru", 
    "hse.ru", 
    "spbstu.ru", 
    "kpfu.ru", 
    "nsu.ru"
  ];

  const isRussianEmail = (email) => {
    return russianDomains.some(domain => email.endsWith(domain));
  };

  const exportToExcel = () => {
    const table = document.getElementById("proyectos-table");
    const rows = table.getElementsByTagName("tr");
    const data = [];
    // Agregar las cabeceras a la matriz de datos
    const headers = ['Nombre', 'Extension', 'Tamaño', 'Fecha', 'Vista previa'];
    data.push(headers);
    // Agregar las filas de datos a la matriz de datos
    for (let i = 1; i < rows.length; i++) {
      const cells = rows[i].getElementsByTagName("td");
      const rowData = [];
      for (let j = 0; j < headers.length; j++) {
        if (headers[j] === 'Vista previa') {
          const link = cells[headers.indexOf('Vista previa')].querySelector('a');
          rowData.push(link ? link.href : URL[i - 1]);
        } else {
          if (headers[j] === 'Nombre') {
            const link = cells[headers.indexOf('Nombre')].querySelector('a');
            rowData.push(link ? link.href : NOMBRE[i - 1]);
          }else{
            if (headers[j] === 'Extension') {
              const link = cells[headers.indexOf('Extension')].querySelector('a');
              rowData.push(link ? link.href : EXTENSION[i - 1]);
            }else{
              if (headers[j] === 'Tamaño') {
                const link = cells[headers.indexOf('Tamaño')].querySelector('a');
                rowData.push(link ? link.href : TAMAñO[i - 1]);
              }else{
                if (headers[j] === 'Fecha') {
                  const link = cells[headers.indexOf('Fecha')].querySelector('a');
                  rowData.push(link ? link.href : FECHA[i - 1]);
                }else{
                  rowData.push(cells[headers.indexOf(headers[j])].innerText);
                }
              }
            }
          }
        }
      }
      data.push(rowData); 
    }
    //Crear una instancia de WorkSheet y agregar los datos
    const XLSX = require("xlsx");
    const ws = XLSX.utils.aoa_to_sheet(data);
    //Configurar el ancho de las columnas para que coincidan con la tabla
    const colWidths = [];
    const tableHeaderCells = table.querySelectorAll(
      "thead th, thead td"
    );
    for (let i = 1; i < tableHeaderCells.length; i++) {
      colWidths.push({
        width:
          tableHeaderCells[i].getBoundingClientRect().width / 10
      });
    }
    ws["!cols"] = colWidths;
    //Crear un libro de trabajo y agregar la hoja de trabajo
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Documentos");
    //Descargar el archivo de Excel
    XLSX.writeFile(
      wb,
      "Documentos.xlsx",
      { bookType: "xlsx", type: "binary" }
    );
  };
 
  //nuevo
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  function formatBytes(bytes) {
    if (bytes === 0) return '0 Bytes';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
  }
  //
  const handleExtensionSelect = (event) => {
    setExtension(event.target.value);
    setExtension2(event.target.value);
    setExtension3(event.target.value);
    setVisible3(false)
  };



  async function loadLEGALES2(profilex) {
    var params = {
      Bucket: S3_BUCKET, 
      Prefix: "documentos/" + profilex + "/",
    };
    const data = await myBucket.listObjectsV2(params).promise();
    let sumSize = 0;
  
    for (const obj of data.Contents) {
      let tamano = obj.Size;
      sumSize += tamano;
    }
  
    setTotalSize(sumSize);
  }


  async function loadLEGALES(profilex, folder = "", cons = 2) {
    let ke;
    if(folder.length > 0){
      ke= "documentos/" + profilex + "/" + folder
    }else{
      ke= "documentos/" + profilex + "/" 
    }

    var params = {
      Bucket: S3_BUCKET,
      Delimiter: "/",
      Prefix: ke
    };
    const data = await myBucket.listObjects(params).promise();
    let datosFiltrados = [];
    let carpetas = [];

    for (let index = 0; index < data.CommonPrefixes.length; index++) {
      let carpeta = data.CommonPrefixes[index].Prefix;
      carpetas.push({
        path: "https://s3.amazonaws.com/www.codeflex.lat" + "/" + carpeta,
        nombre: carpeta.split("/")[carpeta.split("/").length - 2],
        extencion: "carpeta",
        logo: null, 
        tamano: "-", 
        fecha: "-", 
      });
    }

    for (let index = 0; index < data["Contents"].length; index++) {
      let nombre = data["Contents"][index]["Key"].split("/");

      let archivo = data["Contents"][index]["Key"];
      let Extensionm2 = archivo.substring(archivo.lastIndexOf(".") + 1);
      let Extension = Extensionm2;

      let imagenlogo = Extension;

      //nuevo
      let fecha = data["Contents"][index]["LastModified"].toLocaleString();
      let tamano = data["Contents"][index]["Size"];

      let imagenUrl;
      if (imagenlogo.toLowerCase() === "pdf") {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/pdf.png"; 
      } else if (imagenlogo.toLowerCase() === "docx" || imagenlogo.toLowerCase() === "docm"||imagenlogo.toLowerCase() === "dotx"||imagenlogo.toLowerCase() === "dotm" ||imagenlogo.toLowerCase() === "doc" ||imagenlogo.toLowerCase() === "dot") {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/word.png"; 
      } else if (imagenlogo.toLowerCase() === "xls" || imagenlogo.toLowerCase() === "xlsx"||imagenlogo.toLowerCase() === "xlsm"||imagenlogo.toLowerCase() === "xlsb" ||imagenlogo.toLowerCase() === "xltm" ||imagenlogo.toLowerCase() === "xlam" ||imagenlogo.toLowerCase() === "xlr" ||imagenlogo.toLowerCase() === "xlw" ||imagenlogo.toLowerCase() === "xltx" ||imagenlogo.toLowerCase() === "xlt") {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/excel.png"; 
      } else if (imagenlogo.toLowerCase() === "pptx" || imagenlogo.toLowerCase() === "pptm"||imagenlogo.toLowerCase() === "ppt"||imagenlogo.toLowerCase() === "ppam" ||imagenlogo.toLowerCase() === "potx" ||imagenlogo.toLowerCase() === "potm" ||imagenlogo.toLowerCase() === "pot" ||imagenlogo.toLowerCase() === "ppsx" ||imagenlogo.toLowerCase() === "ppsm" ||imagenlogo.toLowerCase() === "pps") {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/powerpoint.png"; 
      }else if (imagenlogo.toLowerCase() === "cs" ) {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/cs.png"; 
      }else if (imagenlogo.toLowerCase() === "c" ) {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/c.png"; 
      }else if (imagenlogo.toLowerCase() === "css" ) {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/css.png"; 
      }else if (imagenlogo.toLowerCase() === "html" ||imagenlogo.toLowerCase() === "htm" || imagenlogo.toLowerCase() === "php") {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/html.png"; 
      }else if (imagenlogo.toLowerCase() === "ai" || imagenlogo.toLowerCase() === "ait") {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/ilustrator.png";  
      }else if (imagenlogo.toLowerCase() === "jpg" || imagenlogo.toLowerCase() === "jpeg"||imagenlogo.toLowerCase() === "gif"||imagenlogo.toLowerCase() === "png" ||imagenlogo.toLowerCase() === "tiff" ||imagenlogo.toLowerCase() === "tif" ||imagenlogo.toLowerCase() === "bmp" ||imagenlogo.toLowerCase() === "svg" ||imagenlogo.toLowerCase() === "jfif" ||imagenlogo.toLowerCase() === "webp"  ||imagenlogo.toLowerCase() === "ico") {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/imagen.png"; 
      }else if (imagenlogo.toLowerCase() === "iso" ) {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/iso.png"; 
      }else if (imagenlogo.toLowerCase() === "js" ) { 
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/js.png"; 
      }else if (imagenlogo.toLowerCase() === "mp3" || imagenlogo.toLowerCase() === "wav"||imagenlogo.toLowerCase() === "aiff"||imagenlogo.toLowerCase() === "flac" ||imagenlogo.toLowerCase() === "aac" ||imagenlogo.toLowerCase() === "ogg" ||imagenlogo.toLowerCase() === "wma") {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/mp3.png"; 
      }else if (imagenlogo.toLowerCase() === "mp4" || imagenlogo.toLowerCase() === "avi"||imagenlogo.toLowerCase() === "mkv"||imagenlogo.toLowerCase() === "mov" ||imagenlogo.toLowerCase() === "flv" ||imagenlogo.toLowerCase() === "mpeg" ||imagenlogo.toLowerCase() === "dv") {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/video.png"; 
      }else if (imagenlogo.toLowerCase() === "psd" || imagenlogo.toLowerCase() === "psb") {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/photoshop.png"; 
      }else if (imagenlogo.toLowerCase() === "pub") {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/publisher.png"; 
      }else if (imagenlogo.toLowerCase() === "rar" || imagenlogo.toLowerCase() === "zip") {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/rar.png"; 
      }else if (imagenlogo.toLowerCase() === "txt") {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/txt.png"; 
      }else if (imagenlogo.toLowerCase() === "py") {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/Python.png"; 
      }else if (imagenlogo.toLowerCase() === "bat") {
        imagenUrl = "https://s3.amazonaws.com/www.codeflex.lat/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/bat.png"; 
      }else if (imagenlogo.toLowerCase() === "c++") {
        imagenUrl = "https://s3.amazonaws.com/www.codeflex.lat/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/c.png";  
      }else if (imagenlogo.toLowerCase() === "exe") {
        imagenUrl = "https://s3.amazonaws.com/www.codeflex.lat/documentos/1b4eec84-2a0d-4cdb-8eb1-404f5204fdcd/Ftoo/exe-icon-21.png"; 
      }else if (imagenlogo.toLowerCase() === "java") {
        imagenUrl = "https://s3.amazonaws.com/www.codeflex.lat/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/java.png"; 
      }else if (imagenlogo.toLowerCase() === "mwb") {
        imagenUrl = "https://s3.amazonaws.com/www.codeflex.lat/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/mwb.png"; 
      }else if (imagenlogo.toLowerCase() === "rdp") {
        imagenUrl = "https://s3.amazonaws.com/www.codeflex.lat/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/remote.png"; 
      }else if (imagenlogo.toLowerCase() === "blend") {
        imagenUrl = "https://s3.amazonaws.com/www.codeflex.lat/documentos/1b4eec84-2a0d-4cdb-8eb1-404f5204fdcd/Ftoo/blender.png"; 
      }else if (imagenlogo.toLowerCase() === "apk") {
        imagenUrl = "https://s3.amazonaws.com/www.codeflex.lat/documentos/1b4eec84-2a0d-4cdb-8eb1-404f5204fdcd/Ftoo/apk.png"; 
      }else if (imagenlogo.toLowerCase() === "bmpr") {
        imagenUrl = "https://s3.amazonaws.com/www.codeflex.lat/documentos/1b4eec84-2a0d-4cdb-8eb1-404f5204fdcd/Ftoo/balsam.png"; 
      }else if (imagenlogo.toLowerCase() === "msi") {
        imagenUrl = "https://s3.amazonaws.com/www.codeflex.lat/documentos/1b4eec84-2a0d-4cdb-8eb1-404f5204fdcd/Ftoo/29527.png"; 
      }else if (imagenlogo.toLowerCase() === "xml") {
        imagenUrl = "https://s3.amazonaws.com/www.codeflex.lat/documentos/1b4eec84-2a0d-4cdb-8eb1-404f5204fdcd/Ftoo/Xml-logo.png"; 
      }else if (imagenlogo.toLowerCase() === "json") {
        imagenUrl = "https://s3.amazonaws.com/www.codeflex.lat/documentos/a423d4ef-3dfb-40a1-9b02-d74ec10e9329/136525.png"; 
      }else if (imagenlogo.toLowerCase() === "enc") {
        imagenUrl = "https://s3.amazonaws.com/www.codeflex.lat/documentos/1b4eec84-2a0d-4cdb-8eb1-404f5204fdcd/aess.png"; 
      }else {
        imagenUrl = "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/documentos.png"; 
      }
      //
      let datox = {
        path: "https://s3.amazonaws.com/www.codeflex.lat" + "/" + data["Contents"][index]["Key"],
        nombre: nombre[cons],
        extencion: Extension,
        logo: imagenUrl,
        tamano: formatBytes(tamano), 
        fecha: fecha
      };

      datosFiltrados.push(datox);
    //Agrega la tabla a un arreglo para excel
      const Nombres = [];
      const Exten = [];
      const tam = [];
      const fech = [];
      const urls = [];

      data.Contents.forEach(item => {
        //Url
        const url = `https://s3.amazonaws.com/www.codeflex.lat/${item.Key}`;
        urls.push(url);
        //Nombre
        const name = item.Key.split("/");
        Nombres.push(name[2])
        //Extension
        const exten = item.Key.split(".");
        Exten.push(exten[1])
        //Tamaño
        const tama = item.Size;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = parseInt(Math.floor(Math.log(tama) / Math.log(1024)), 10);
        const val = Math.round(tama / Math.pow(1024, i), 2) + sizes[i]
        tam.push(val)
        //Fecha
        const fecha = item.LastModified;
        fech.push(fecha) 
      });
      setNOMBRE(Nombres);
      setEXTENSION(Exten);
      setTAMAñO(tam)
      setFECHA(fech)
      setURL(urls);
    //Fin 
      
    }
    datosFiltrados = [...carpetas, ...datosFiltrados];
    SetDatos(datosFiltrados);
    setCargandoTabla(false);
  }

  const borrar = async (filename) => { 
    //console.log(filename);
    const params = {
      Bucket: S3_BUCKET,
      Key: "documentos/" + sub + "/" + filename
    };
      try {
          await myBucket.deleteObject(params).promise()
          //console.log("file deleted Successfully")
          alert("Archivo: " + filename + " eliminado con exito")
          window.location.reload()
      }
      catch (err) {
          console.log("ERROR in file Deleting : " + JSON.stringify(err))
      }
  } 

  const modal2 = async () => { 
    setVisible2(true)
  } 
  const modal3 = async () => { 
    setVisible6(true)
  } 
  const ModalTipo = async () => { 
    setVisible3(true)
  } 
  
  const  copiar = async (url, nombre) => {

    let overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Generando Url Corta...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);	

    let ruta;
    if (url.endsWith('.pdf')) {
      ruta = `https://s3.amazonaws.com/pdf.codeflex.com.co/web/viewer.html?file=${url}`;
    } else if (url.endsWith('.docx') || url.endsWith('.doc') || url.endsWith('.xlsx') || url.endsWith('.xls') || url.endsWith('.pptx') || url.endsWith('.ppt')|| url.endsWith('.docm')|| url.endsWith('.dotx')|| url.endsWith('.dotm')|| url.endsWith('.dot')|| url.endsWith('.xlsm')|| url.endsWith('.xlsb')|| url.endsWith('.xltm')|| url.endsWith('.xlam')|| url.endsWith('.xlr')|| url.endsWith('.xlw')|| url.endsWith('.xltx')|| url.endsWith('.pptm')|| url.endsWith('.ppam')|| url.endsWith('.potx')|| url.endsWith('.potm')|| url.endsWith('.pot')|| url.endsWith('.ppsx')|| url.endsWith('.ppsm')|| url.endsWith('.pps')|| url.endsWith('.Ppa')) {
      ruta = `https://view.officeapps.live.com/op/embed.aspx?src=${url}`;
    } else {
      ruta = url;
    } 

    const jsonData = {
      "longUrl": ruta
    } 

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(jsonData)
    };

    fetch("https://go.codeflex.com.co/consultarurl", options)
    .then(response => response.json()) // Parsea la respuesta como JSON
    .then(data => {
      // Convierte la cadena JSON en un objeto JavaScript
      const responseObject = JSON.parse(data.body);
      // Extrae el valor de la propiedad 'shortUrl' del objeto
      const shortUrl = responseObject.shortUrl;

      let nuevo = "https://go.fipuc.org/"+shortUrl;

      const isIframe = window.self !== window.top;

      if (isIframe) {
        alert("Por favor, subraya y copia la URL: " + nuevo);
        document.body.removeChild(overlay);
      }else{
        navigator.clipboard.writeText(nuevo).then(() => {
          alert("URL cortada copiada: " + nuevo);
          document.body.removeChild(overlay);
        }).catch((error) => {
          console.error("Error al copiar la URL cortada: ", error);
          document.body.removeChild(overlay);
        });
      }
   
    })
    .catch(error => {
      console.error("Error al acortar la URL: ", error);
      document.body.removeChild(overlay);
    });
  
  };


  const  copiar2 = async (url, nombre) => {

    let overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Generando Url...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);	

    let ruta;
    if (url.endsWith('.pdf')) {
      ruta = `https://s3.amazonaws.com/pdf.codeflex.com.co/web/viewer.html?file=${url}`;
    } else if (url.endsWith('.docx') || url.endsWith('.doc') || url.endsWith('.xlsx') || url.endsWith('.xls') || url.endsWith('.pptx') || url.endsWith('.ppt')|| url.endsWith('.docm')|| url.endsWith('.dotx')|| url.endsWith('.dotm')|| url.endsWith('.dot')|| url.endsWith('.xlsm')|| url.endsWith('.xlsb')|| url.endsWith('.xltm')|| url.endsWith('.xlam')|| url.endsWith('.xlr')|| url.endsWith('.xlw')|| url.endsWith('.xltx')|| url.endsWith('.pptm')|| url.endsWith('.ppam')|| url.endsWith('.potx')|| url.endsWith('.potm')|| url.endsWith('.pot')|| url.endsWith('.ppsx')|| url.endsWith('.ppsm')|| url.endsWith('.pps')|| url.endsWith('.Ppa')) {
      ruta = `https://view.officeapps.live.com/op/embed.aspx?src=${url}`;
    } else {
      ruta = url;
    } 

    setTimeout(function(){
      const isIframe = window.self !== window.top;

      if (isIframe) {
        alert("Por favor, subraya y copia la URL: " + ruta);
        document.body.removeChild(overlay);
      }else{
        navigator.clipboard.writeText(ruta).then(() => {
          alert("URL Copiada: " + ruta);
          document.body.removeChild(overlay);
        }).catch((error) => {
          console.error("Error al copiar la URL: ", error);
          document.body.removeChild(overlay);
        });
      }
     },750)

  };

  const Verpdf = (url) => {
    const ruta = url;
    window.open(`https://s3.amazonaws.com/pdf.codeflex.com.co/web/viewer.html?file=${ruta}`,"_blank");
  }
  const Verdoc = (url) => {
    const ruta = url;
    window.open(`https://view.officeapps.live.com/op/embed.aspx?src=${ruta}`,"_blank");
  };
  
  const [checkbox, setCheckbox] = useState(false)
  const [archivosSeleccionados, setArchivosSeleccionados] = useState([])
  const identificar = async () => { 
    var inputElems = document.getElementsByTagName("input"),
    count = 0;
    for (var i=0; i<inputElems.length; i++) {
      if (inputElems[i].type === "checkbox" && inputElems[i].checked === true){
          count++;
      }
    }                               
    if(count >1){
      setCheckbox(true)
    }else{ 
      setCheckbox(false)
    }

    console.log(count)
  }  

  const selected = (event, archivo) => {
    if (event.target.checked) {
      setArchivosSeleccionados([...archivosSeleccionados, archivo]);
    } else {
      setArchivosSeleccionados(
        archivosSeleccionados.filter((a) => a !== archivo)
      );
    }
  };
 
  const refrescar = () => {
    window.location.reload()
  };

  const eliminarArchivosSeleccionados = async () => {

    let overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Eliminando...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);	

    const eliminaciones = archivosSeleccionados.map((archivo) => {
      const params = { Bucket: S3_BUCKET, Key: archivo.replace("https://s3.amazonaws.com/www.codeflex.lat/", "") };
      return myBucket.deleteObject(params).promise();
    });
  
    // Verificar si los archivos seleccionados incluyen carpetas
    const carpetasSeleccionadas = archivosSeleccionados.filter(archivo => archivo.endsWith('/'));
  
    console.log(carpetasSeleccionadas);
  
    // Si hay carpetas seleccionadas, eliminar todos los archivos internos de esas carpetas
    if (carpetasSeleccionadas.length > 0) {
      const archivosInternos = await obtenerArchivosInternos(carpetasSeleccionadas);
      console.log('Archivos internos de las carpetas a eliminar:', archivosInternos);
  
      // Eliminar todos los archivos internos
      const eliminacionesArchivosInternos = archivosInternos.map((archivo) => {
        const params = { Bucket: S3_BUCKET, Key: archivo };
        return myBucket.deleteObject(params).promise();
      });
  
      eliminaciones.push(...eliminacionesArchivosInternos);
    }
  
    try {
      await Promise.all(eliminaciones);
      // Actualiza la lista de archivos después de eliminar los seleccionados
      alert("Archivos eliminados con éxito");
      document.body.removeChild(overlay);
      const profilex = sub;
      // window.location.reload()
      loadLEGALES(profilex, carpe, numeroSubcarpeta);
      loadLEGALES2(sub);
      setVisible2(false)
      setArchivosSeleccionados([]);
      setCheckbox(false)
    } catch (error) {
      alert("Error al eliminar los archivos");
      document.body.removeChild(overlay);
      window.location.reload()
      console.log(error);
    }
  };
  
  
  // Esta función obtiene todos los archivos internos de las carpetas seleccionadas
  const obtenerArchivosInternos = async (carpetas) => {
    const archivosInternos = [];
  
    for (const carpeta of carpetas) {
      const carpetaKey = carpeta.replace("https://s3.amazonaws.com/www.codeflex.lat/", "");
      const params = {
        Bucket: S3_BUCKET,
        Prefix: carpetaKey,
      }; 
  
      try { 
        const response = await myBucket.listObjectsV2(params).promise();
        const archivosEnCarpeta = response.Contents.map(obj => obj.Key);
  
        // Excluye la propia carpeta de la lista de archivos internos
        const archivosInternosDeCarpeta = archivosEnCarpeta.filter(archivo => archivo !== carpetaKey);
        archivosInternos.push(...archivosInternosDeCarpeta);
      } catch (error) {
        console.error(`Error al listar archivos internos de la carpeta ${carpetaKey}:`, error);
      }
    }
  
    return archivosInternos; 
  };
  
  let nombreCarpeta;

  const renombrar = async () => {
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Cargando...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);
  
    const renombrarObjeto = async (archivo) => {
      const key = archivo.substring(archivo.indexOf('documentos/'));
      let nuevoNombre = Input2
      try {
        const apiUrl = "https://api.codeflex.com.co/editars3";
        const requestBody = {
          key: key,
          nuevoNombre: nuevoNombre
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(requestBody)
        });
        if (!response.ok) {
          throw new Error(`Error de red: ${response.status}`);
        }
        const data = await response.json();
        if (data) {
          document.body.removeChild(overlay);
          const profilex = sub;
          alert("El nombre se ha cambiado con éxito.");
          // window.location.reload()
          loadLEGALES(profilex, carpe, numeroSubcarpeta);
          loadLEGALES2(sub);
          setVisible6(false)
          setArchivosSeleccionados([]);
          setCheckbox(false)
        } else {
          document.body.removeChild(overlay);
          alert("Fallo en el servidor");
        }
      } catch (error) {
        document.body.removeChild(overlay);
        console.error('Error:', error);
      }
    };
  
    for (const archivo of archivosSeleccionados) {
      await renombrarObjeto(archivo);
    }
  
  };



  const descargar = async () => {
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Downloading';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);
  
    const descargarArchivo = async (archivo) => {
      const key = archivo.substring(archivo.indexOf('documentos/'));
      const nombreArchivo = key.split('/').pop();
      nombreCarpeta = key.split('/').filter(part => part !== '').pop();

      console.log(archivo)
      console.log(key)
      console.log(nombreArchivo)
      console.log(nombreCarpeta)

      try {
        if (archivo.endsWith("/")) {
          // Descargar carpeta
          try {
            const apiUrl = "https://xo8cblasg3.execute-api.us-east-1.amazonaws.com/produccion/zip";
            const requestBody = {
              keey: key,
              nameC: key.split('/').filter(part => part !== '').pop()
            };
            const response = await fetch(apiUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(requestBody)
            });
  
            if (!response.ok) {
              throw new Error(`Error de red: ${response.status}`);
            }
  
            const data = await response.json();
  
            if (data) {
              await carpetass(archivo);
            } else {
              alert("Fallo en el servidor");
            }
          } catch (error) {
            console.error("Error al llamar a la API Lambda:", error);
          }
        } else {
          // Descargar archivo individual
          try {
            const response = await fetch(archivo, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/octet-stream',
              },
            });
  
            if (response.ok) {
              const blob = await response.blob();
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.download = nombreArchivo;
              link.click();
              window.URL.revokeObjectURL(url);
              console.log('File downloaded:', archivo);
              console.log('Nombre:', nombreArchivo);
            } else {
              console.error('Error downloading file:', archivo);
            }
          } catch (error) {
            console.error('Error downloading file:', archivo, error);
          }
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };
  
    // Iterar sobre archivos seleccionados y descargar cada uno
    for (const archivo of archivosSeleccionados) {
      await descargarArchivo(archivo);
    }
  
    document.body.removeChild(overlay);
  };
  
  const carpetass = async (archivo) => {
    const keey = archivo + nombreCarpeta + ".zip";
    const key = keey.substring(keey.indexOf('documentos/'));
    const nombreArchivo = key.split('/').pop();
  
    try {
      const response = await fetch(keey, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/octet-stream',
        },
      });
  
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = nombreCarpeta + ".zip";
        link.click();
        window.URL.revokeObjectURL(url);
        console.log('File downloaded:', keey);
        console.log('Nombre:', nombreArchivo);
        alert("NOTA: La descarga de carpetas genera un archivo .zip con el nombre '" + nombreCarpeta + "' , el cual se guarda en la carpeta que deseas descargar.");
      } else {
        console.error('Error downloading file:', keey);
      }
    } catch (error) {
      console.error('Error downloading file:', keey, error);
    }
  };
  
  
   

  const cargarSonido44 = function () {
    const sonido2 = document.createElement("audio");
    sonido2.src = 'https://s3.amazonaws.com/perfil.primerosauxilios.online/voz/speech_20230514021444596.mp3';
    sonido2.setAttribute("preload", "auto");
    sonido2.setAttribute("controls", "none");
    sonido2.style.display = "none"; // <-- oculto
    document.body.appendChild(sonido2);
    return sonido2;
    };
    const sonido2 = cargarSonido44("sonido.flac");
   function playere() {
      sonido2.play()
   };

   const Ver = (url) => {
    const ruta = url;   
    window.open(ruta,"_blank");
  }


  const abrirCarpeta = (carpetaNombre) => {
    setSearchInput("");
    setExtension("");
    setExtension2("");
    setExtension3("Todos los archivos");
    setCargandoTabla(true);
    loadSubfolder(sub, carpetaNombre);
  };

  async function loadSubfolder(profilex, folder = "") {
    const currentFolderName = currentFolder[currentFolder.length - 1] || "";
    const newFolderName = folder.endsWith("/") ? folder : folder + "/";
    const folderNameToLoad = currentFolderName + newFolderName;
    setCurrentFolder((prevFolders) => [...prevFolders, folderNameToLoad]);
    setCarpe(folderNameToLoad);
    const nuevoContadorSubcarpeta = numeroSubcarpeta + 1;
    setNumeroSubcarpeta(nuevoContadorSubcarpeta);

    setTimeout(function(){
     loadLEGALES(profilex, folderNameToLoad,nuevoContadorSubcarpeta);
    },200)
  }
  
  const volverACarpetaPrincipal = () => {
    setCargandoTabla(true);
    const prevFolders = [...currentFolder];
    prevFolders.pop();
    setCurrentFolder(prevFolders);
    const folderToLoad = prevFolders[prevFolders.length - 1] || "";
    setCarpe(folderToLoad);
    const nuevoContadorSubcarpeta = numeroSubcarpeta - 1;
    setNumeroSubcarpeta(nuevoContadorSubcarpeta);
    setTimeout(function(){
      loadLEGALES(sub, folderToLoad,nuevoContadorSubcarpeta);
    },200)

  };



  const etiqueta = (filePath) => {

    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Cambiando el acceso...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);

    // Extraer la parte relativa del filePath sin la URL base
    const key = filePath.replace('https://s3.amazonaws.com/www.codeflex.lat/', '');

    const params = {
        Bucket: S3_BUCKET,
        Key: key,
    };

    // Consultar las etiquetas del objeto
    myBucket.getObjectTagging(params, (err, data) => {
        if (err) {
            document.body.removeChild(overlay);
            console.log('Error al obtener las etiquetas:', err);
            alert('Error al obtener las etiquetas.');
            return;
        }

        // Verificar si ya tiene la etiqueta 'Acceso'
        const accesoEtiqueta = data.TagSet.find(tag => tag.Key === 'Acceso');

        if (accesoEtiqueta && accesoEtiqueta.Value === 'private') {
            // Si tiene la etiqueta 'Acceso' con valor 'private', eliminarla
            const deleteParams = {
                Bucket: S3_BUCKET,
                Key: key,
                Tagging: {
                    TagSet: data.TagSet.filter(tag => tag.Key !== 'Acceso') // Eliminar la etiqueta
                }
            };

            myBucket.putObjectTagging(deleteParams, (err) => {
                if (err) {
                    document.body.removeChild(overlay);
                    console.log('Error al eliminar la etiqueta:', err);
                    alert('Error al eliminar la etiqueta.');
                } else {
                    document.body.removeChild(overlay);
                    alert('Archivo público');
                }
            });
        } else {
            // Si no tiene la etiqueta 'Acceso' o tiene un valor diferente, agregarla
            const addParams = {
                Bucket: S3_BUCKET,
                Key: key,
                Tagging: {
                    TagSet: [...data.TagSet, { Key: 'Acceso', Value: 'private' }] // Agregar la etiqueta
                }
            };

            myBucket.putObjectTagging(addParams, (err) => {
                if (err) {
                    document.body.removeChild(overlay);
                    console.log('Error al agregar la etiqueta:', err);
                    alert('Error al agregar la etiqueta.');
                } else {
                    document.body.removeChild(overlay);
                    alert('Archivo bloqueado públicamente');
                }
            });
        }
    });
  };




  const fipuc = (filePath) => {

    const confirmPublish = window.confirm("¿Está seguro de publicar esta carpeta en FIPUC Hosting?");

    if (!confirmPublish) {
      return;
    }

    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Subiendo a FIPUC...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);


    const apiUrl = "https://api.codeflex.com.co/fipuc";
    const requestBody = {
      url: filePath,
      username: sub
    };
  
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(requestBody)
    })
      .then(response => {
        if (!response.ok) {
          document.body.removeChild(overlay);
          throw new Error(`Error de red: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {

        if (data.status == "Éxito"){
          alert("Su página web ya se encuentra en: https://pages.fipuc.org/");
          document.body.removeChild(overlay);
        }else{
          alert("Error interno: " + data.error);
          document.body.removeChild(overlay);
        }

      })
      .catch(error => {
        document.body.removeChild(overlay);
        console.error("Error al llamar a la API Lambda:", error);
      });

  };


  const abrirhtml = (url) => {
  let visor;
  visor = url;
  setviso(visor);
  var partes = url.split('/');
  var parteRecortada = partes.slice(6).join('/');
  seteditedFileName(parteRecortada)
  cargarHtml(url);
  };

  const visor = () => {
    const rutaArchivo = viso;
    const rutaCarpetaPrincipal = rutaArchivo.substring(0, rutaArchivo.lastIndexOf('/') + 1);
    openIndexHTML(rutaCarpetaPrincipal);
  }
  
  let popupWindow =null;
  const openIndexHTML = async (ruta) => {
    try {
      const indexHTMLURL = `${ruta}index.html`;
      const randomAttribute = `?timestamp=${new Date().getTime()}`;
      const cacheBustURL = indexHTMLURL + randomAttribute;

      const response = await fetch(cacheBustURL, {cache: 'no-store'});
      if (response.status === 200) {
        let urls = cacheBustURL;
        if (window.popupWindow && !window.popupWindow.closed) {
          window.popupWindow.location.href = urls;
          window.popupWindow.focus();
        } else {
          const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
          const windowWidth = 900;
          const windowHeight = 600;
          const windowLeft = (screenWidth - windowWidth) / 2;
          const windowTop = (screenHeight - windowHeight) / 2;
          window.popupWindow = window.open(urls, '_blank', `width=${windowWidth},height=${windowHeight},top=${windowTop},left=${windowLeft}`);
          if (window.popupWindow) {
            window.popupWindow.focus();
          }
        }
      } else {
        const rutaSinUltimaCarpeta = ruta.slice(0, ruta.lastIndexOf('/', ruta.length - 2) + 1);
        if (ruta === rutaSinUltimaCarpeta) {
          alert('No se encontró un archivo index.html en ninguna carpeta.');
          return;
        }
        await openIndexHTML(rutaSinUltimaCarpeta);
      }
    } catch (error) {
      console.error('Error al abrir el archivo index.html:', error);
    }
  };

  useEffect(() => {
    // Verifica si ya se mostró la notificación de activación
    const notificationsEnabled = localStorage.getItem('notificationsEnabled');
  
    // Comprueba el estado actual del permiso de notificaciones
    if (Notification.permission === "denied" || Notification.permission === "default") {
      // Si el permiso está denegado o aún no se ha pedido (default),
      // se elimina la marca de 'notificationsEnabled' para permitir volver a mostrar la solicitud
      localStorage.removeItem('notificationsEnabled'); 
    }
  
    if (!notificationsEnabled) {
      Notification.requestPermission().then(permission => {
        if (permission === "granted") {
          // Si el permiso es otorgado y no se ha enviado la notificación antes
          const options = {
            body: 'Te notificaremos cada vez que tus archivos terminen de subirse.',
            icon: 'https://codeflex.com.co/assets/img/modificacion2.png',
            image: 'https://codeflex.com.co/assets/img/gg2.webp'
          };
  
          new Notification("Notificaciones Activadas", options);
  
          // Guarda en localStorage que la notificación ya fue enviada
          localStorage.setItem('notificationsEnabled', 'true');
        }
      });
    }
  }, []);
  
  
  const cargarHtml = async (url) => {
    try {
      const randomAttribute = `?timestamp=${new Date().getTime()}`;
      const cacheBustURL = url + randomAttribute;
      const response = await fetch(cacheBustURL, {cache: 'no-store'});
      const html = await response.text();

      let language = 'html'; 
      if (url.endsWith('.css')) {
        language = 'css';
      } else if (url.endsWith('.js')) {
        language = 'javascript';
      }else if (url.endsWith('.py')) {
        language = 'python';
      }else if (url.endsWith('.txt')) {
        language = 'plaintext'; // Utiliza 'plaintext' para archivos .txt
      }

      setHtmlContent(html);
      setEditorLanguage(language);
      setVisible(true);

      setTimeout(() => {
        const cargando = document.getElementById("loader") 
        cargando.style.display="none"
        setmostrar(true)
      }, 1800);

    } catch (error) {
      console.error('Error al cargar el HTML:', error);
    }
  };
  const [htmlContent, setHtmlContent] = useState('');
  const [viso, setviso] = useState('');
  const [mostrar, setmostrar] = useState(false);
  const [viso3, setviso3] = useState('');
  const [editedFileName, seteditedFileName] = useState('');
  const [editorLanguage, setEditorLanguage] = useState('');
  const [visibletr, setvisibletr] = useState(false)


  const guardarHtml = async () => {
    const cargando = document.getElementById("cargando3") 
    cargando.style.display="block"
    let exten = '';
    if (editedFileName.endsWith('.html')) {
      exten = 'text/html';
    } else if (editedFileName.endsWith('.css')) {
      exten = 'text/css';
    } else {
      exten = 'text/js';
    }
    const params = {
      Bucket: S3_BUCKET,
      Key: `documentos/${sub}/${editedFileName}`,
      Body: htmlContent,
      ContentType: exten,
    };
    try {
      await myBucket.putObject(params).on('httpUploadProgress', function (progress) {
        if (progress.loaded === progress.total) {
          setvisibletr(true)
          //alert("Archivo HTML/CSS/JS/PY guardado con éxito.")
          const cargando = document.getElementById("cargando3") 
          cargando.style.display="none"

          setTimeout(function(){
            setvisibletr(false)
          },1500)
          
        }
      }).promise();
    } catch (error) {
      console.error('Error al guardar el HTML en S3:', error);
    }
  };

  const [toast, addToast] = useState(0)
  const toaster = useRef()
  const exampleToast = (
  <CToast> 
    <CToastHeader closeButton>
      <svg
        className="rounded me-2"
        width="20"
        height="20"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid slice"
        focusable="false"
        role="img"
      >
        <rect width="100%" height="100%" fill="#007aff"></rect>
      </svg>
      <div className="fw-bold me-auto">Cloud Storage Service</div>
    </CToastHeader>
    <CToastBody>Archivo HTML/CSS/JS/PY guardado con éxito.</CToastBody>
  </CToast>
  )


  const [resultados, setResultados] = useState([]);
  const compilar = () => {

    let overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Cargando...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);


    const apiUrl = "https://xo8cblasg3.execute-api.us-east-1.amazonaws.com/produccion/python";
    const requestBody = {
      url: viso
    };
  
    // Extraer el nombre del archivo desde el viso (URL)
    const nombreArchivo = viso.split('/').pop();  // Obtiene el último segmento de la URL (nombre del archivo)
  
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(requestBody)
    })
      .then(response => {
        if (!response.ok) {
          document.body.removeChild(overlay);
          throw new Error(`Error de red: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        let popupContent = '';
  
        // Si el statusCode es 200
        if (data.statusCode === 200) {
          // Eliminar solo las comillas dobles y mantener los corchetes
          popupContent = data.body.replace(/"|\[|\]/g, match => match === "[" || match === "]" ? match : '').replace(/\\n/g, '\n');
        }
  
        // Si el statusCode es 500
        if (data.statusCode === 500) {
          let bodyData;
          try {
            // Intentar parsear la respuesta si es un objeto
            bodyData = JSON.parse(data.body);
          } catch (e) {
            // Si no se puede parsear, usar el mensaje tal como vino
            bodyData = data.body;
          }
  
          let responseText = '';
  
          // Si es un objeto con Error, Consulta y Respuesta
          if (bodyData.Error || bodyData.Consulta || bodyData["Respuesta de Codeflex AI"]) {
            responseText += `<span style="color: #569CD6;">"Error":</span> <span style="color: #F48771;">${bodyData.Error ? bodyData.Error : 'No se proporcionó un error.'}</span><br/><br/>`;
            responseText += `<span style="color: #569CD6;">Consulta:</span> ${bodyData.Consulta ? bodyData.Consulta : 'No se proporcionó una consulta.'}<br/><br/>`;
            responseText += `<span style="color: #569CD6;">Respuesta de Codeflex AI:</span><br/>${bodyData["Respuesta de Codeflex AI"] ? bodyData["Respuesta de Codeflex AI"] : 'No se proporcionó respuesta de Codeflex AI.'}`;
            
            // Si hay bloques de código Python, resaltarlos
            if (responseText.includes('```python')) {
              responseText = responseText.replace(/```python([\s\S]*?)```/g, (match, codeBlock) => {
                return `<span style="color: #DCDCAA; background-color: #1E1E1E; padding: 10px; display: block; font-family: 'Courier New', monospace;">${codeBlock}</span>`;
              });
            }
          } else {
            // Si no hay Error, Consulta o Respuesta, mostrar el contenido tal cual
            responseText = bodyData;
          }
  
          // Abrir una nueva ventana emergente
          const popup = window.open('', 'popup', 'width=600,height=400');
  
          // Asegurarse de que la ventana se haya abierto correctamente
          if (popup) {
            popup.document.write(`
              <style>
                body {
                  background-color: black;
                  color: white;
                  font-family: "Courier New", Courier, monospace;
                  padding: 10px;
                }
                pre {
                  white-space: pre-wrap;
                  word-wrap: break-word;
                }
                .highlight {
                  color: #569CD6; /* Azul para los títulos */
                }
                .error {
                  color: #F48771; /* Rojo claro para errores */
                }
              </style>
              <pre>
C:\\Users\\Codeflex\\Documents>python ${nombreArchivo}<br/>
${responseText}
              </pre>
            `);
          } else {
            document.body.removeChild(overlay);
            console.log('No se pudo abrir la ventana emergente');
          }
        } else {
          // Si el statusCode es 200, utilizar un estilo más sencillo
          const popup = window.open('', 'popup', 'width=600,height=400');
          if (popup) {
            popup.document.write(`
              <style>
                body {
                  background-color: black;
                  color: white;
                  font-family: "Courier New", Courier, monospace;
                  padding: 10px;
                }
                pre {
                  white-space: pre-wrap;
                  word-wrap: break-word;
                }
              </style>
              <pre>
C:\\Users\\Codeflex\\Documents>python ${nombreArchivo}<br/>
${popupContent}
              </pre>
            `);
          } else {
            document.body.removeChild(overlay);
            console.log('No se pudo abrir la ventana emergente');
          }
        }
        document.body.removeChild(overlay);
      })
      .catch(error => {
        document.body.removeChild(overlay);
        console.error("Error al llamar a la API Lambda:", error);
      });
  };
  
  
  
  
  
  
  
  const [dato, setDato] = useState({});

  async function leerWidgets() {
    const params = {
      TableName: DYNAMODB_TABLE_WIDGETS,
      Key: {
        username: "Administrador",
      },
    };

    try {
      const data = await dynamodb.get(params).promise();
      let datosx = data.Item;

      const datosValidados = {};
      for (const key in datosx) {
        if (datosx.hasOwnProperty(key)) {
          datosValidados[key] = datosx[key];
        }
      }

      setDato(datosValidados);
      
    } catch (err) {
      console.error('Error al buscar:', err);
    }
  }
  


  async function leerptoyectos(sub) {
    const params = {
      TableName: DYNAMODB_TABLE_NAME, 
      Key: {
        token: sub,
      },
    };
  
    try {
      const data = await dynamodb.get(params).promise();
      if (data.Item) {
        let validado = data.Item.premium;
        SetDB(validado);
      } else {
        console.log('Usuario no encontrado.');
      }
    } catch (err) {
      console.error('Error al buscar usuario:', err);
    }
  }

  const formatTime = (seconds) => {
    if (seconds > 3600) {  // si es mayor a 1 hora
      return `${Math.floor(seconds / 3600)}h ${Math.floor((seconds % 3600) / 60)}m ${seconds % 60}s`; // mostrar en formato "horas minutos segundos"
    } else if (seconds > 60) { // si es mayor a 1 minuto
      return `${Math.floor(seconds / 60)}m ${seconds % 60}s`; // mostrar en formato "minutos segundos"
    } else {
      return `${seconds}s`; // mostrar solo segundos
    }
  };

  const cancelUpload = (name) => {
    const file = datos2.find(result => result.name === name);
    if (file) {
      const request = file.request;
      request.abort();
      SetDatos2(old => old.filter(result => result.name !== name));
      alert(`El archivo ${name} fue cancelado`);
    }
  };

 
  async function subirurl(){

    if(urlimagen.length > 0){

    let overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Cargando...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);


    const jsonData = {
      "Buckets": "www.codeflex.lat",
      "ProviderSub": sub,
      "Url": urlimagen,
      "Ket": "documentos/" + sub + "/" + carpe
    };

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(jsonData)
    };

    fetch("https://api.codeflex.com.co/Image", options)
    .then(response => response.json()) // Parsea la respuesta como JSON
    .then(data => {

      if (data.body.length > 0){
      alert("Imagen creada con éxito");
      document.body.removeChild(overlay);
      //window.location.reload()
      seturlimagen("")
      loadLEGALES(sub, carpe, numeroSubcarpeta);
      loadLEGALES2(sub);
      }else{
        alert("Error al crear Imagen");
        document.body.removeChild(overlay);
      }

    })
    .catch(error => {
      console.error("Error al enviar: ", error);
      alert("Error al crear Imagen");
      document.body.removeChild(overlay);
    });


  }

};



  const Subir = async (file, name) => { 
    const params = {
      ACL: 'public-read',
      Body: file,
      Bucket: S3_BUCKET, 
      ContentType: file.type,
      Key: "documentos/" + sub + "/" +  carpe + name
    };
    const startTime = new Date().getTime();
    return new Promise((resolve, reject) => {
        const request = myBucket.putObject(params);
        request.on('httpUploadProgress', (progressEvent) => {
          const elapsedTime = new Date().getTime() - startTime;
          SetDatos2(old => {
            const index = old.findIndex(result => result.name === name);
            const newData = { ...old[index], progress: Math.round((progressEvent.loaded / progressEvent.total) * 100), request, tiempo: Math.ceil((elapsedTime / progressEvent.loaded) * (progressEvent.total - progressEvent.loaded) / 1000) };
            old.splice(index, 1, newData);
            return [...old];
          });
        });
		    setActivado(true);
        request.send((err) => {
          if (err) { 
            if (err.code === 'RequestAbortedError') {
              reject({ name, error: 'canceled' });
            } else {
              reject(err);
            }
          } else {
            resolve();
          } 
        });
    });
  };

  const [subiendo, setSubiendo] = useState(false)

  const handleDrop = async (event) => {
    event.preventDefault();
    setShowDropArea(false);
    setSubiendo(true);
    const items = event.dataTransfer.items;
    const droppedFiles = [];
    let folderContainsManyFiles = false; // Bandera para verificar si la carpeta contiene más de 80 archivos
  
    const processItem = async (item, folderPath = '') => {
      const entry = item.webkitGetAsEntry();
  
      if (entry.isDirectory) {
        await processDirectory(entry, folderPath + '/' + entry.name);
      } else {
        let file = await getFileFromEntry(entry, folderPath);
        if (file) {
          droppedFiles.push(file);
        }
      }
    };
  
    const processItems = async (items) => {
      const itemPromises = [];
      for (let i = 0; i < items.length; i++) {
        itemPromises.push(processItem(items[i]));
      }
      await Promise.all(itemPromises);
  
      if (droppedFiles.length > 95) { // Verifica si hay más de 80 archivos
        folderContainsManyFiles = true;
      }
  
      if (folderContainsManyFiles) {
        alert("Hay alguna carpeta que contiene más de 95 archivos. Por favor, utilice 'Agregar Carpeta' o 'Agregar Archivos' para cargar.");
        setSubiendo(false);
        return;
      }
  
      // Ahora envía los archivos a la función Subir y agrega los nombres a los datos
      const uploadPromises = [];
      droppedFiles.forEach((file) => {
        const name = file.name;
        let datox = {
          "name": name,
          "progress": 0
        };
        SetDatos2((old) => [...old, datox]);
        uploadPromises.push(Subir(file, name));
      });
      Promise.all(uploadPromises)
        .then(() => {
          if (Notification.permission === "denied" || Notification.permission === "default") {
            alert("Todos los archivos se han subido con éxito");
          }
  
          Notification.requestPermission().then(permission => {
            if (permission === "granted") {
              const options = {
                body: 'Todos los archivos se han subido con éxito.',
                icon: 'https://codeflex.com.co/assets/img/modificacion2.png'
              };
              new Notification("", options);
            }
          });
  
          //alert("Todos los archivos se han subido con éxito");
          SetDatos2([]);
          setActivado(false);
          loadLEGALES(sub, carpe, numeroSubcarpeta);
          loadLEGALES2(sub);
          setSubiendo(false);
          //window.location.reload()
        })
        .catch((error) => {
          if (error === "canceled") {
            alert(`El archivo ${error.name} fue cancelado`);
            SetDatos((old) => old.filter((result) => result.name !== error.name));
          } else {
            alert("Error al subir uno o más archivos: Fallo en el servidor, o Cancelación");
            setSubiendo(false);
          }
        });
    };
  
    const processDirectory = async (directory, folderPath) => {
      const reader = directory.createReader();
      const entries = await readEntries(reader);
  
      const entryPromises = entries.map((entry) => {
        if (entry.isDirectory) {
          return processDirectory(entry, folderPath + '/' + entry.name);
        } else {
          return getFileFromEntry(entry, folderPath).then((file) => {
            if (file) {
              droppedFiles.push(file);
            }
          });
        }
      });
  
      await Promise.all(entryPromises);
    };
  
    const readEntries = (reader) => {
      return new Promise((resolve) => {
        reader.readEntries((entries) => {
          resolve(entries);
        });
      });
    };
  
    const getFileFromEntry = (entry, folderPath) => {
      return new Promise((resolve) => {
        entry.file((file) => {
          // Eliminar la primera barra diagonal del nombre de la carpeta
          folderPath = folderPath.replace(/^\//, '');
          // Agregar el nombre de la carpeta al nombre del archivo
          const fileName = folderPath ? `${folderPath}/${file.name}` : file.name;
          file = new File([file], fileName, { type: file.type });
          resolve(file);
        }, (error) => {
          console.error(error);
          resolve(null);
        });
      });
    };
  
    await processItems(items);
  };
  
  
  
  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    setShowDropArea(true);
  };

  const handleDragEnterLeave = (event) => {
    event.preventDefault();
  
    if (event.type === 'dragenter') {
      setShowDropArea(true);
    } else {
      // Aquí comprobamos si el puntero del mouse se encuentra fuera del área de la página
      if (event.clientX < 10 || event.clientY < 10 || event.clientX > window.innerWidth - 10 || event.clientY > window.innerHeight - 10) {
        setShowDropArea(false);
      }
    }
  };



  
  

  useEffect(() => {
    // Agrega eventos globales para detectar cuando el usuario acerca o aleja un archivo
    document.addEventListener('dragenter', handleDragEnterLeave);
    document.addEventListener('dragover', handleDragEnterLeave);
    document.addEventListener('dragleave', handleDragEnterLeave);

    return () => {
      // Limpia los eventos al desmontar el componente
      document.removeEventListener('dragenter', handleDragEnterLeave);
      document.removeEventListener('dragover', handleDragEnterLeave);
      document.removeEventListener('dragleave', handleDragEnterLeave);
    };
  }, []);

  const [showDropArea, setShowDropArea] = useState(false);

  const [Html, setHtml] = useState("index")
  const [Css, setCss] = useState("style")
  const [Js, setJs] = useState("app")
  const [Py, setPy] = useState("clase")
  const [Txt, setTxt] = useState("documento")
  const [namecarpeta2, seNamecarpeta2] = useState("")
  const [YouTubeMp4, setYouTubeMp4] = useState("")
  const [YouTubeMp3, setYouTubeMp3] = useState("")


  //HTML2
  const createHtmlFile2 = async () => {

    let overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Cargando...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);	


    const htmlContent = `<!--HTML-->
<!DOCTYPE html>
<html lang="es">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
    <link rel="stylesheet" href="" /> <!--Nombre del .css-->
    <link rel="icon" type="image/png" sizes="16x16" href="https://codeflex.com.co/assets/img/modificacion2.png"> <!--Logo-->
    <title>Titulo.</title>
    <script src="https://cdn.userway.org/widget.js" data-account="d6fnrKp9B5"></script> <!--Accesibilidad By Codeflex S.A.S. (opcional)-->
    <style>
      body {
        font-family: 'Arial', sans-serif;
        background-color: #f2f2f2;
        margin: 0;
        padding: 0;
      }
      .contenedor {
        background-color: #ffffff;
        padding: 20px;
        text-align: center;
        border-radius: 10px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        margin: 20px auto;
        max-width: 690px;
      }
      h1 {
        color: #333333;
      }
      p {
        color: #666666;
        font-size: 18px;
        line-height: 1.6;
        margin-bottom: 20px;
      }
      .cita {
        font-style: italic;
        color: #888888;
      }
    </style>
  </head>
  <body>
    <div className="contenedor">
      <h1>
        ¡Bienvenido ${nombre} a <br/>Codeflex S.A.S.!
      </h1>
      <p>
        Es un placer tenerte en este proyecto. ¡Prepárate para crear y elaborar cosas asombrosas!
      </p>
      <p className="cita">
        "El único modo de hacer un gran trabajo es amar lo que haces." - Steve Jobs
      </p>
    </div>
    <p style="text-align: center; color: #888888; font-size: 14px; margin-top: 20px;">
      Fecha de elaboración del HTML: ${Date().toLocaleString('es-ES')}
    </p>
    <script src=""></script> <!--Nombre del .js-->
  </body>
</html>
    `;
    const params = {
      ACL: 'public-read',
      Body: htmlContent,
      Bucket: S3_BUCKET,
      ContentType: 'text/html',
      Key: "documentos/" + sub + "/" + carpe  + Html+".html"
    };
    try {
      await myBucket.putObject(params).promise();
      alert("Archivo HTML creado con éxito");
      document.body.removeChild(overlay);
      //window.location.reload()
      loadLEGALES(sub, carpe, numeroSubcarpeta);
      loadLEGALES2(sub);
    } catch (error) {
      console.error("Error al crear el archivo HTML:", error);
      alert("Error al crear el archivo HTML");
      document.body.removeChild(overlay);
    }
  };
  //CSS2
  const createCssFile2 = async () => {

    let overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Cargando...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);	


    const htmlContent = `/*CSS*/`;
    const params = {
      ACL: 'public-read',
      Body: htmlContent,
      Bucket: S3_BUCKET,
      ContentType: 'text/css',
      Key: "documentos/" + sub + "/" + carpe  + Css+".css"
    };
    try {
      await myBucket.putObject(params).promise();
      alert("Archivo CSS creado con éxito");
      document.body.removeChild(overlay);
      //window.location.reload()
      loadLEGALES(sub, carpe, numeroSubcarpeta);
      loadLEGALES2(sub);
    } catch (error) {
      console.error("Error al crear el archivo CSS:", error);
      alert("Error al crear el archivo CSS");
      document.body.removeChild(overlay);
    }
  };
  //JS2
  const createJsFile2 = async () => {

    let overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Cargando...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);	

    const htmlContent = `//JavaScript`;
    const params = {
      ACL: 'public-read',
      Body: htmlContent,
      Bucket: S3_BUCKET,
      ContentType: 'text/js',
      Key: "documentos/" + sub + "/" + carpe + Js+".js"
    };
    try {
      await myBucket.putObject(params).promise();
      alert("Archivo JS creado con éxito");
      document.body.removeChild(overlay);
      //window.location.reload()
      loadLEGALES(sub, carpe, numeroSubcarpeta);
      loadLEGALES2(sub);
    } catch (error) {
      console.error("Error al crear el archivo JS:", error);
      alert("Error al crear el archivo JS");
      document.body.removeChild(overlay);
    }
  };
  //PYTHON2
  const createpyFile2 = async () => {

    let overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Cargando...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);	

    const htmlContent =`
class Saludo:
    def __init__(self, mensaje):
        self.mensaje = mensaje

    def saludar(self):
        print(self.mensaje)

# Crear una instancia de la clase Saludo
saludo = Saludo("Hola mundo")

# Llamar al método saludar
saludo.saludar()
`;
    const params = {
      ACL: 'public-read',
      Body: htmlContent,
      Bucket: S3_BUCKET,
      ContentType: 'text/x-python',
      Key: "documentos/" + sub + "/" + carpe  + Py+".py"
    };
    try {
      await myBucket.putObject(params).promise();
      alert("Archivo Python creado con éxito");
      document.body.removeChild(overlay);
      //window.location.reload()
      loadLEGALES(sub, carpe, numeroSubcarpeta);
      loadLEGALES2(sub);
    } catch (error) {
      console.error("Error al crear el archivo Python:", error);
      alert("Error al crear el archivo Python");
      document.body.removeChild(overlay);
    }
  };




  //PYTHON2
  const createtxtFile2 = async () => {

    let overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Cargando...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);	

    const htmlContent =`
Estamos comprometidos en mantener segura tu información personal y tomamos medidas
técnicas y organizativas adecuadas para protegerla contra accesos no autorizados, pérdida, 
divulgación o alteración. Garantizamos la confidencialidad de la información (Decreto 1377 de 2013).
`;
    const params = {
      ACL: 'public-read',
      Body: htmlContent,
      Bucket: S3_BUCKET,
      ContentType: 'text/plain',
      Key: "documentos/" + sub + "/" + carpe  + Txt+".txt"
    };
    try {
      await myBucket.putObject(params).promise();
      alert("Archivo Txt creado con éxito");
      document.body.removeChild(overlay);
      //window.location.reload()
      loadLEGALES(sub, carpe, numeroSubcarpeta);
      loadLEGALES2(sub);
    } catch (error) {
      console.error("Error al crear el archivo Txt:", error);
      alert("Error al crear el archivo Txt");
      document.body.removeChild(overlay);
    }
  };



  //PYTHON2
  const createmp4File2 = async () => {

    let overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Cargando...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);	

    const jsonData = {
      "Buckets": "www.codeflex.lat",
      "ProviderSub": sub,
      "Url": YouTubeMp4,
      "Ket": "documentos/" + sub + "/" + carpe
    };

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(jsonData)
    };

    fetch("https://api.codeflex.com.co/Mp4", options)
    .then(response => response.json()) // Parsea la respuesta como JSON
    .then(data => {

      if (data.body.length > 0){
      alert("YouTube Mp4 creado con éxito");
      document.body.removeChild(overlay);
      //window.location.reload()
      setYouTubeMp4("")
      loadLEGALES(sub, carpe, numeroSubcarpeta);
      loadLEGALES2(sub);
      }else{
        alert("Error al crear el YouTube Mp4");
        document.body.removeChild(overlay);
      }

    })
    .catch(error => {
      console.error("Error al enviar: ", error);
      alert("Error al crear el YouTube Mp4");
      document.body.removeChild(overlay);
    });
  };


    //PYTHON2
    const createmp3File2 = async () => {

      let overlay = document.createElement('div');
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
      overlay.style.display = 'flex';
      overlay.style.flexDirection = 'column';
      overlay.style.justifyContent = 'center';
      overlay.style.alignItems = 'center';
      overlay.style.zIndex = '9999';
      const spinner = document.createElement('div');
      spinner.className = 'spinner-border text-primary';
      spinner.setAttribute('role', 'status');
      const srOnly = document.createElement('span');
      srOnly.className = 'visually-hidden';
      srOnly.textContent = '';
      const downloadingText = document.createElement('p');
      downloadingText.textContent = 'Cargando...';
      downloadingText.style.marginTop = '10px';
      spinner.appendChild(srOnly);
      overlay.appendChild(spinner);
      overlay.appendChild(downloadingText);
      document.body.appendChild(overlay);	
  
      const jsonData = {
        "Buckets": "www.codeflex.lat",
        "ProviderSub": sub,
        "Url": YouTubeMp3,
        "Ket": "documentos/" + sub + "/" + carpe
      };
  
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(jsonData)
      };
  
      fetch("https://api.codeflex.com.co/Mp3", options)
      .then(response => response.json()) // Parsea la respuesta como JSON
      .then(data => {
  
        if (data.body.length > 0){
        alert("YouTube Mp3 creado con éxito");
        document.body.removeChild(overlay);
        setYouTubeMp3("")
        //window.location.reload()
        loadLEGALES(sub, carpe, numeroSubcarpeta);
        loadLEGALES2(sub);
        }else{
          alert("Error al crear el YouTube Mp3");
          document.body.removeChild(overlay);
        }
  
      })
      .catch(error => {
        console.error("Error al enviar: ", error);
        alert("Error al crear el YouTube Mp3");
        document.body.removeChild(overlay);
      });
  
  
    };


 
  const fileInputRef = useRef(null);

  // Función para abrir el cuadro de diálogo de selección de archivos
  const abrirSelectorDeArchivos = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };


    const fileInputRef2 = useRef(null);

  // Función para abrir el cuadro de diálogo de selección de archivos
  const abrirSelectorDeArchivos2 = () => {
    if (fileInputRef2.current) {
      fileInputRef2.current.click();
    }
  };

  const [inputKey, setInputKey] = useState(Date.now());
  const [inputKey2, setInputKey2] = useState(Date.now());

  // ARRASTRAR
  const change = async (e) => {

    setSubiendo(true)
    const files = e.target.files;
    const uploadPromises = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const name = files[i].name;
      let datox = { 
        "name" : name,
        "progress": 0 
      }; 
      SetDatos2(old => [...old, datox]); 
      uploadPromises.push(Subir2(file, name ));
    }
    Promise.all(uploadPromises).then(() => {

      if (Notification.permission === "denied" || Notification.permission === "default") {
        alert("Todos los archivos se han subido con éxito");
      }

      Notification.requestPermission().then(permission => {
        if (permission === "granted") {
          const options = {
            body: 'Todos los archivos se han subido con éxito.',
            icon: 'https://codeflex.com.co/assets/img/modificacion2.png'
          };
          new Notification("", options);        
        }
      });


      //alert("Todos los archivos se han subido con éxito");
      //window.location.reload()
      setSubiendo(false)
      SetDatos2([]);
      setActivado(false);
      loadLEGALES(sub, carpe, numeroSubcarpeta);
      loadLEGALES2(sub);
      setInputKey(Date.now()); // Esto remontará el input, reseteándolo
    }).catch((error) => {
      if (error === "canceled") {
        alert(`El archivo ${error.name} fue cancelado`);
        SetDatos2(old => old.filter(result => result.name !== error.name));
      } else {
        alert("Error al subir uno o más archivos: Fallo en el servidor, o Cancelacion");
        setSubiendo(false)
      }
    });
  }; 

  const Subir2 = async (file, name) => { 
    const params = {
      ACL: 'public-read',
      Body: file,
      Bucket: S3_BUCKET,
      ContentType: file.type,
      Key: "documentos/" + sub + "/" +  carpe + name
    };
    const startTime = new Date().getTime();
    return new Promise((resolve, reject) => {
        const request = myBucket.putObject(params);
        request.on('httpUploadProgress', (progressEvent) => {
          const elapsedTime = new Date().getTime() - startTime;
          SetDatos2(old => {
            const index = old.findIndex(result => result.name === name);
            const newData = { ...old[index], progress: Math.round((progressEvent.loaded / progressEvent.total) * 100), request, tiempo: Math.ceil((elapsedTime / progressEvent.loaded) * (progressEvent.total - progressEvent.loaded) / 1000) };
            old.splice(index, 1, newData);
            return [...old];
          });
        });
        setActivado(true);
        request.send((err) => {
          if (err) { 
            if (err.code === 'RequestAbortedError') {
              reject({ name, error: 'canceled' });
            } else {
              reject(err);
            }
          } else {
            resolve();
          } 
        });
    });
  };

  const [loading, setLoading] = useState(true);

  const change3 = async (e) => {
 
    setSubiendo(true)
    const files = e.target.files;
    const uploadPromises = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const name = file.webkitRelativePath; 
      let datox = { 
        "name" : name,
        "progress": 0 
      }; 
      SetDatos2(old => [...old, datox]); 
      uploadPromises.push(Subir3(file, name ));
    }
    Promise.all(uploadPromises).then(() => {

      if (Notification.permission === "denied" || Notification.permission === "default") {
        alert("Todos los archivos se han subido con éxito");
      }

      Notification.requestPermission().then(permission => {
        if (permission === "granted") {
          const options = {
            body: 'Todos los archivos se han subido con éxito.',
            icon: 'https://codeflex.com.co/assets/img/modificacion2.png'
          };
          new Notification("", options);        
        }
      });

      //alert("Todos los archivos se han subido con éxito");
      setSubiendo(false)
      SetDatos2([]);
      setActivado(false);
      loadLEGALES(sub, carpe, numeroSubcarpeta);
      loadLEGALES2(sub);
      setInputKey2(Date.now()); // Esto remontará el input, reseteándolo
     //window.location.reload()
    }).catch((error) => {
      if (error === "canceled") {
        alert(`El archivo ${error.name} fue cancelado`);   
        SetDatos2(old => old.filter(result => result.name !== error.name));
      } else {
        alert("Error al subir uno o más archivos: Fallo en el servidor, o Cancelacion");
        setSubiendo(false)
      }
    });
  };

  const Subir3 = async (file, name) => {
    const params = {
      ACL: 'public-read',
      Body: file,
      Bucket: S3_BUCKET,
      ContentType: file.type,
      Key: "documentos/" + sub + "/" +  carpe + name
    };
    const startTime = new Date().getTime();
    return new Promise((resolve, reject) => {
        const request = myBucket.putObject(params);
        request.on('httpUploadProgress', (progressEvent) => {
          const elapsedTime = new Date().getTime() - startTime;
          SetDatos2(old => {
            const index = old.findIndex(result => result.name === name);
            const newData = { ...old[index], progress: Math.round((progressEvent.loaded / progressEvent.total) * 100), request, tiempo: Math.ceil((elapsedTime / progressEvent.loaded) * (progressEvent.total - progressEvent.loaded) / 1000) };
            old.splice(index, 1, newData);
            return [...old];
          });
        });
        setActivado(true);
        request.send((err) => { 
          if (err) { 
            if (err.code === 'RequestAbortedError') {
              reject({ name, error: 'canceled' });
            } else {
              reject(err);
            }
          } else {
            resolve();
          } 
        });
    });
  };

  const [visiblee, setVisiblee] = useState(false)
  const [repet,SetRepetir] = useState("");


  const cargarSonido = function () {
    const sonido = document.createElement("audio");
    sonido.src = 'https://s3.amazonaws.com/perfil.primerosauxilios.online/voz/speech_20230514015221090.mp3';
    sonido.setAttribute("preload", "auto");
    sonido.setAttribute("controls", "none");
    sonido.style.display = "none"; // <-- oculto
    document.body.appendChild(sonido);
    return sonido;
    };
    const sonido = cargarSonido("sonido.flac");

   function playe() {
    sonido.play()
   }; 
 
   const db = async () => { 

    const contenidoArchivo = `
    Bienvenidos a Codeflex.
    
    Políticas de Privacidad:
    Esta Política de Privacidad describe cómo se recopilan, utilizan y
    protegen los datos personales que nos proporcionas al utilizar nuestros servicios. 
    Tu privacidad es de suma importancia para nosotros, y nos comprometemos a proteger tus datos de 
    acuerdo con las leyes y regulaciones aplicables (Ley Estatutaria 1581 de 2012).
    
    Estamos comprometidos en mantener segura tu información personal y tomamos medidas 
    técnicas y organizativas adecuadas para protegerla contra accesos no autorizados, pérdida, 
    divulgación o alteración. Garantizamos la confidencialidad de la información (Decreto 1377 de 2013).
    
    Derechos y Responsabilidades del Usuario:
    Como usuario de Codeflex, tienes la capacidad de editar, subir, almacenar y eliminar tus 
    archivos en la plataforma. Es tu responsabilidad asegurar el correcto manejo de los mismos, 
    y Codeflex no se hace responsable por la pérdida o daño de archivos resultante de acciones dentro de tu cuenta. 
    Te instamos a mantener una copia de seguridad de tus archivos importantes para prevenir cualquier inconveniente.
    
    NOTA: El mal uso de este servicio puede conllevar la deshabilitación de tu cuenta o eliminación. 
    En caso de que se presente un mal uso, se notificará al correo: ${email}.
    
    *CODEFLEX S.A.S., Empresa de almacenamiento y Desarrollador Web.
    `;

    const params2 = {
      Bucket: S3_BUCKET,
      Key: "documentos/" + sub + "/" + "README.txt",
      ACL: 'public-read', // Ajusta los permisos según sea necesario
      Body: contenidoArchivo,
      ContentType: 'text/plain',
    };
  
    try {
      await myBucket.putObject(params2).promise();
      console.log("Licencia Correcta")
    } catch (error) {
      console.error("Error al crear la Licencia en S3:", error);
    }


    let valida;

    const params = {
      TableName: DYNAMODB_TABLE_NAME,
      ProjectionExpression: "email",
    };
  
    try {
      const data = await dynamodb.scan(params).promise();
      let emailEncontrado = false; 
  
      if (data.Items && data.Items.length > 0) {
        data.Items.forEach(item => {

          const emaill = item.email.toLowerCase().trim();
          const emailToCompare = email.toLowerCase().trim();

          if (emaill === emailToCompare) {
            emailEncontrado = true;
          }

          
        });

        if (emailEncontrado) {
          console.log("llego1")
          valida = "true";
        } else {
          console.log("llego2")
          valida = "false";
        }

      } else {
        console.log('No se encontraron proyectos.');
      }
    } catch (err) {
      console.error('Error al buscar proyectos:', err);
    }

    if (premium2 === "true"){
      setVisiblee(false)
    }else if(valida === "true"){ 
        alert("Usuario ya registrado")
      }else{
        const cargando = document.getElementById("cpinner") 
        cargando.style.display="block"

        const esCorreoEducativo = email.endsWith('.edu') || // Estados Unidos
                                  email.endsWith('.una.ac.cr') || // Costa rica UNA
                                  email.endsWith('.edu.co') || // Colombia
                                  isRussianEmail(email) || // Rusia
                                  email.endsWith('.edu.ar') || // Argentina
                                  email.endsWith('.edu.mx') || // México
                                  email.endsWith('.edu.es') || // España
                                  email.endsWith('.edu.ve') || // Venezuela
                                  email.endsWith('.edu.br'); // Brasil

        const dynamoParams = {
          TableName: DYNAMODB_TABLE_NAME,
          Item: {
            token: usuario,
            sub: sub,
            timeid: new Date().toISOString(),
            premium: esCorreoEducativo ? true : false,
            email: email, 
            nombre: nombre,    
            telefono: tel, 
            cedula: profile,
            plan: esCorreoEducativo ? "EDUCACION" : "gratuito",
            valor:"0",
          },
        };

        dynamodb.put(dynamoParams, (err, data) => { 
          if (err) {
            alert("el usuario ya se encuentra registrado")
            console.log(err);
          } else {

            if(esCorreoEducativo){
              infocorreo(email);
              console.log("es educativo")
            }else{
              console.log("no es educativo")
              websit();
            }
          }
        });
      }

  }

  async function infocorreo(emaiss) {
    const url = `https://sjdwqogwxkm2cdrbjwkxweuxuy0pzacn.lambda-url.us-east-1.on.aws/?correo=${emaiss}`;

    fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json(); 
    })
    .then(data => {
      enviaconfirmacion(emaiss,data.titulo)
    })
    .catch(error => {
      console.error('Error al hacer la petición:', error);
    });
    
}


async function enviaconfirmacion(email6, origen) {
  console.log(origen)
  const jsonData2 = {
    "nombre": "Gerencia",
    "mensaje": `¡Genial! Se acaba de activar el plan institucional, asignado al correo (${email6}) perteneciente a (${origen}). Ahora tienes acceso a almacenamiento ilimitado, CodeFlex Polly, phpMyAdmin, soporte premium, y más. Estas herramientas están listas para elevar tus proyectos. ¿Listo para explorar? Te recomendamos ver nuestras guías de inicio rápido. ¡Felicidades! Estamos aquí para apoyarte. Disfruta de las nuevas posibilidades.`,
    "To": `${email6}`,
  };

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(jsonData2)
  };

  fetch("https://api.codeflex.com.co/smtp", options)
  .then(response => response.json()) // Parsea la respuesta como JSON
  .then(data => {
    console.log("llego")
    websit();
  })
  .catch(error => {
    console.error("Error al enviar: ", error);
  });
}
 
  async function websit(){
      try {
        await updateUserAttributes({
          userAttributes: {
            website: "true"
          },
        }).then(data => 
        {

        setTimeout(async function(){
          const cargando = document.getElementById("cpinner") 
          cargando.style.display="none"
          setVisible(false)
          alert("Usuario creado en la base de datos, por favor vuelve a iniciar sesión.")
          signOut();
          window.location.reload();
        },1000)

        });
      } catch (err) {
        console.log(err);
      }

   } 



  const [visible5, setVisible5] = useState(false)
  const [namecarpeta, setnamecarpeta] = useState("")
  const [urlimagen, seturlimagen] = useState("")
  
  const modalcarpeta = async () => { 
    setVisible5(true)
  } 

const crearcarpeta = async () => {
  if(namecarpeta.length > 0){
    if (namecarpeta.endsWith('/')) {
      alert('El nombre de la carpeta no puede terminar en /');
    } else {
      await crearCarpetaEnS3(namecarpeta);
    }
  }else{
    alert('Campo Vacío');
  }

}

const crearCarpetaEnS3 = async (nombreCarpeta) => {


  let overlay = document.createElement('div');
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
  overlay.style.display = 'flex';
  overlay.style.flexDirection = 'column';
  overlay.style.justifyContent = 'center';
  overlay.style.alignItems = 'center';
  overlay.style.zIndex = '9999';
  const spinner = document.createElement('div');
  spinner.className = 'spinner-border text-primary';
  spinner.setAttribute('role', 'status');
  const srOnly = document.createElement('span');
  srOnly.className = 'visually-hidden';
  srOnly.textContent = '';
  const downloadingText = document.createElement('p');
  downloadingText.textContent = 'Cargando...';
  downloadingText.style.marginTop = '10px';
  spinner.appendChild(srOnly);
  overlay.appendChild(spinner);
  overlay.appendChild(downloadingText);
  document.body.appendChild(overlay);	


  const contenidoArchivo = `
  Bienvenidos a Codeflex: carpeta '${nombreCarpeta}' creada con éxito.
  CODEFLEX S.A.S., Empresa de almacenamiento y Desarrollador Web.
  `;
  
  const params = {
    Bucket: S3_BUCKET,
    Key: "documentos/" + sub + "/" + carpe + nombreCarpeta + "/" + "Licencia.txt",
    ACL: 'public-read', // Ajusta los permisos según sea necesario
    Body: contenidoArchivo,
    ContentType: 'text/plain',
  };

  try {
    await myBucket.putObject(params).promise();
    alert(`Carpeta ${nombreCarpeta} creada con éxito`);
    document.body.removeChild(overlay);
    setnamecarpeta("")
    setVisible5(false)
    loadLEGALES(sub, carpe, numeroSubcarpeta);
    
    //window.location.reload()
  } catch (error) {
    console.error("Error al crear la carpeta en S3:", error);
    alert("Error al crear la carpeta");
    document.body.removeChild(overlay);
  }
};
 

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key.toLowerCase() === 's' && visible) {
        event.preventDefault(); // Prevenir el comportamiento predeterminado de Ctrl+S
        guardarHtml();
      }

      if(viso.endsWith('.py')){

        if (event.ctrlKey && event.key.toLowerCase() === 'b' && visible) {
          event.preventDefault(); // Prevenir el comportamiento predeterminado de Ctrl+d
          compilar();
        }

      }else{

        if (event.ctrlKey && event.key.toLowerCase() === 'q' && visible) {
          event.preventDefault(); // Prevenir el comportamiento predeterminado de Ctrl+d
          visor();
        }

      }


    };

    // Añadir el controlador de eventos al documento
    document.addEventListener('keydown', handleKeyDown);

    // Remover el controlador de eventos al desmontar el componente
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [visible, htmlContent,viso]);
  const [collapse, setCollapse] = useState(false);

  const toggle = () => setCollapse(!collapse);

  return (
    <DashboardLayout>
    <DashboardNavbar />

    <CModal visible={visiblee}
    style={{
      position: 'fixed',
      width: '100%',
      height: '100%',
      background: 'rgba(255, 255, 255, 1)',
      display: 'flex',
      flexDirection: 'column',
      zIndex: 9999,
    }}
    onClose={() => setVisiblee(false)}
    >
        <CModalHeader id='tas1'>
          <CModalTitle>Bienvenidos!</CModalTitle>
        </CModalHeader>
        <CModalBody style={{fontSize:"16px"}}>¡Gracias por preferirnos! Estamos encantados de darte la bienvenida a nuestra plataforma de almacenamiento. Antes de que comiences a utilizar nuestros servicios, te pedimos que aceptes nuestras políticas de privacidad, las cuales son fundamentales para regir nuestra empresa (Ley 1581 de 2012).</CModalBody>
        <CModalFooter>
          <CButton color="info" onClick={() => playe()}>
            Leer
          </CButton>
          <CButton color="warning" onClick={() => db()}>
            Aceptar
          </CButton>
          <CSpinner color="primary" variant="grow" style={{display:"none"}} id='cpinner' />
        </CModalFooter>
    </CModal>


    {mfa ? 
    <></>
    :
    <CAlert color="warning" dismissible visible={true} style={{fontSize:"15.4px"}}>
      <CAlertHeading component="h4">Recomendación de Seguridad</CAlertHeading>
      <p>Para proteger mejor sus archivos, active la autenticación de doble factor (MFA). Esto proporciona seguridad adicional, asegurando que solo usted tenga acceso a su cuenta. <i><strong>Accede a tu perfil de usuario y da clic en "(Activar MFA | SMS)"</strong></i> para prevenir accesos no autorizados.</p>
    </CAlert>
    }

  <CAlert color="success" dismissible visible={true} style={{fontSize:"13.5px"}}>
    <CAlertHeading component="h4">Archivos Grandes</CAlertHeading>
    <p>Para subir archivos que pesen más de 4.5 GB, ve al menú de la izquierda y entra a <strong>Multipart</strong>. Los archivos subidos allí se cargan uno por uno, y se agregarán en la raíz o en la carpeta que desees.</p>
  </CAlert>


  <CAlert color="dark" dismissible visible={true} style={{fontSize:"13.5px"}}>
    <CAlertHeading component="h4">Sistema de Seguridad de Cifrado AES</CAlertHeading>
    <p>Disponemos de un sistema de seguridad de cifrado AES. En el siguiente manual podrás evidenciar cómo cifrar y proteger claves: <a href="https://go.fipuc.org/Manual_Cifrado" target="_blank" rel="noopener noreferrer">Manual de Cifrado</a>. La página web de cifrado JSON es: <a href="https://codeflex.com.co/CifrarJSON/" target="_blank" rel="noopener noreferrer">Cifrado JSON</a>, y de cifrado para imágenes es: <a href="https://codeflex.com.co/CifrarIMG/" target="_blank" rel="noopener noreferrer">Cifrado Imágenes</a>.</p>
  </CAlert>



    {premium2 === "true" ?
    <>
    <SoftBox py={3}> 
    <>

        <CCol mb={3}>
        <CCard className="mb-4">
        <CCardBody>
          
          <span> 
          <SoftTypography variant="h6"> <strong>Almacenamiento</strong>
            <span>
              {email.endsWith('.edu') ||  email.endsWith('.una.ac.cr') ||  email.endsWith('.edu.co') || email.endsWith('.edu.ar') || isRussianEmail(email) || email.endsWith('.edu.mx') ||  email.endsWith('.edu.es') || email.endsWith('.edu.br') || email.endsWith('.edu.ve') ?
              <>
                <span style={{color:"blue"}}> (Plan Institucional)</span>
                
                  {email.endsWith('.edu.co') && (
                    <CIcon style={{width:"21px"}} icon={cifCo} />
                  )}

                  {email.endsWith('.edu') && (
                    <CIcon style={{width:"24px"}} icon={cifUs} />
                  )}

                  {email.endsWith('.una.ac.cr') && (
                    <CIcon style={{width:"24px"}} icon={cifCr} />
                  )}

                  {email.endsWith('.edu.ar') && (
                    <CIcon style={{width:"22px"}} icon={cifAr} />
                  )}

                  {email.endsWith('.edu.mx') && (
                    <CIcon style={{width:"23px"}} icon={cifMx} />
                  )} 

                  {email.endsWith('.edu.es') && (
                    <CIcon style={{width:"21px"}} icon={cifEs} />
                  )}

                  {email.endsWith('.edu.br') && (
                    <CIcon style={{width:"22px"}} icon={cifBr} />
                  )}

                  {email.endsWith('.edu.ve') && (
                    <CIcon style={{width:"22px"}} icon={cifVe} />
                  )}

                  {isRussianEmail(email) && (
                    <CIcon style={{width:"22px"}} icon={cifRu} />
                  )}
                
              </>
              :
              <>
                {base  ?
                <>
                <span style={{color:"blue"}}> (Modo Premium)</span><i style={{color:"orange"}} className="fas fa-crown"></i>
                </>
                :
                <>
                <span> (Modo Gratuito)</span>
                </>
                }  
              </>
              }  
              </span>
            </SoftTypography>
          </span>

            {email.endsWith('.edu') ||  email.endsWith('.una.ac.cr') ||  email.endsWith('.edu.co') || email.endsWith('.edu.ar') || email.endsWith('.edu.mx') ||  email.endsWith('.edu.es') || email.endsWith('.edu.br') || email.endsWith('.edu.ve') || isRussianEmail(email) ?
              <>
                <div className="d-flex align-items-center flex-grow-1">
                  <CProgress className="w-100">
                  {Math.floor((totalSize / (14 * 1024 * 1024 * 1024)) * 100) < 33 && (
                      <CProgressBar id="verdeprogreso" color="success"  variant="striped" animated value={(totalSize / (14 * 1024 * 1024 * 1024)) * 100}>{Math.floor((totalSize / (14 * 1024 * 1024 * 1024)) * 100)}%</CProgressBar>
                      )} 
                      {Math.floor((totalSize / (14 * 1024 * 1024 * 1024)) * 100) >= 33 && Math.floor((totalSize / (14 * 1024 * 1024 * 1024)) * 100) < 66 && (
                        <CProgressBar id="naranjaprogreso" color="warning"  variant="striped" animated value={(totalSize / (14 * 1024 * 1024 * 1024)) * 100}>{Math.floor((totalSize / (14 * 1024 * 1024 * 1024)) * 100)}%</CProgressBar>
                      )}
                      {Math.floor((totalSize / (14 * 1024 * 1024 * 1024)) * 100) >= 66 && (
                      <CProgressBar id="rojoprogreso" color="danger"  variant="striped" animated value={(totalSize / (14 * 1024 * 1024 * 1024)) * 100}>{Math.floor((totalSize / (14 * 1024 * 1024 * 1024)) * 100)}%</CProgressBar>
                  )}
                  </CProgress> 
                </div>  
                <SoftTypography variant="h6"><span>{formatBytes(totalSize)} de 14GB en uso</span></SoftTypography>
              </>
              :
              <>
                {base  ?
                  <>
                    <div className="d-flex align-items-center flex-grow-1">
                      <CProgress className="w-100">
                      {Math.floor((totalSize / (300 * 1024 * 1024 * 1024)) * 100) < 33 && (
                          <CProgressBar id="verdeprogreso" color="success"  variant="striped" animated value={(totalSize / (300 * 1024 * 1024 * 1024)) * 100}>{Math.floor((totalSize / (300 * 1024 * 1024 * 1024)) * 100)}%</CProgressBar>
                          )} 
                          {Math.floor((totalSize / (300 * 1024 * 1024 * 1024)) * 100) >= 33 && Math.floor((totalSize / (300 * 1024 * 1024 * 1024)) * 100) < 66 && (
                            <CProgressBar id="naranjaprogreso" color="warning"  variant="striped" animated value={(totalSize / (300 * 1024 * 1024 * 1024)) * 100}>{Math.floor((totalSize / (300 * 1024 * 1024 * 1024)) * 100)}%</CProgressBar>
                          )}
                          {Math.floor((totalSize / (300 * 1024 * 1024 * 1024)) * 100) >= 66 && (
                          <CProgressBar id="rojoprogreso" color="danger"  variant="striped" animated value={(totalSize / (300 * 1024 * 1024 * 1024)) * 100}>{Math.floor((totalSize / (300 * 1024 * 1024 * 1024)) * 100)}%</CProgressBar>
                      )}
                      </CProgress> 
                    </div>  
                    <SoftTypography variant="h6"><span>{formatBytes(totalSize)} de 300GB en uso</span></SoftTypography>
                  </>
                  :
                  <>
                    <div className="d-flex align-items-center flex-grow-1">
                      <CProgress className="w-100">
                        {Math.floor((totalSize / (7 * 1024 * 1024 * 1024)) * 100) < 33 && (
                        <CProgressBar id="verdeprogreso" color="success"  variant="striped" animated value={(totalSize / (7 * 1024 * 1024 * 1024)) * 100}>{Math.floor((totalSize / (7 * 1024 * 1024 * 1024)) * 100)}%</CProgressBar>
                        )} 
                        {Math.floor((totalSize / (7 * 1024 * 1024 * 1024)) * 100) >= 33 && Math.floor((totalSize / (7 * 1024 * 1024 * 1024)) * 100) < 66 && (
                          <CProgressBar id="naranjaprogreso" color="warning"  variant="striped" animated value={(totalSize / (7 * 1024 * 1024 * 1024)) * 100}>{Math.floor((totalSize / (7 * 1024 * 1024 * 1024)) * 100)}%</CProgressBar>
                        )}
                        {Math.floor((totalSize / (7 * 1024 * 1024 * 1024)) * 100) >= 66 && (
                        <CProgressBar id="rojoprogreso" color="danger"  variant="striped" animated value={(totalSize / (7 * 1024 * 1024 * 1024)) * 100}>{Math.floor((totalSize / (7 * 1024 * 1024 * 1024)) * 100)}%</CProgressBar>
                        )}
                      </CProgress> 
                    </div> 
                    <SoftTypography variant="h6"><span>{formatBytes(totalSize)} de 7GB en uso</span></SoftTypography>
                  </>
                }  
              </>
            } 
          </CCardBody>
        </CCard>
      </CCol>
      </><br/>

      <CCol mb={3}>
        <CCard className="mb-4">
        <CCardBody>
        {subiendo ?   
        <>
        <CAlert color="success" dismissible visible={true}>
        <CAlertHeading component="h4">Advertencia!</CAlertHeading>
              <p>Si cambia de menú o refresca la página, los archivos no se subirán. Los archivos se subirán uno por uno, conforme a lo indicado en la tabla de abajo. Se le notificará mediante una alerta cuando todos los archivos hayan sido subidos.</p>
              <hr />
              <p className="mb-0">Drive© 2024.</p>
        </CAlert>
        </>
        :
        <>



        {email.endsWith('.edu') ||  email.endsWith('.una.ac.cr') ||  email.endsWith('.edu.co') || email.endsWith('.edu.ar') || email.endsWith('.edu.mx') ||  email.endsWith('.edu.es') || email.endsWith('.edu.br') || email.endsWith('.edu.ve') || isRussianEmail(email) ?
          <>
            {Math.floor((totalSize / (14 * 1024 * 1024 * 1024)) * 100) < 100 ?  
              <CButton
                  size="sm"
                  onClick={toggle}
                >
                  {collapse ? 'Ocultar' : 'Mostrar'} Widgets
              </CButton>
            :
              <CButton
                  size="sm"
                  disabled
                >
                  Sin Almacenamiento
              </CButton>
            }
          </>
          :
          <>
            {base  ?
              <>
                {Math.floor((totalSize / (300 * 1024 * 1024 * 1024)) * 100) < 100 ?  
                  <CButton
                      size="sm"
                      onClick={toggle}
                    >
                      {collapse ? 'Ocultar' : 'Mostrar'} Widgets
                  </CButton>
                :
                  <CButton
                      size="sm"
                      disabled
                    >
                      Sin Almacenamiento
                  </CButton>
                }
              </>
            :
              <>
                {Math.floor((totalSize / (7 * 1024 * 1024 * 1024)) * 100) < 100 ?  
                  <CButton
                      size="sm"
                      onClick={toggle}
                    >
                      {collapse ? 'Ocultar' : 'Mostrar'} Widgets
                  </CButton>
                  :
                  <CButton
                      size="sm"
                      disabled
                    >
                      Sin Almacenamiento
                  </CButton>
                }
              </>
            }
          </>
        }

        <CCollapse visible={collapse}>
         <br/>

          <Grid container spacing={3}>

          {dato["Archivo(IMAGEN)"] === true && (
            <>


            {email.endsWith('.edu') ||  email.endsWith('.una.ac.cr') ||  email.endsWith('.edu.co') || email.endsWith('.edu.ar') || email.endsWith('.edu.mx') ||  email.endsWith('.edu.es') || email.endsWith('.edu.br') || email.endsWith('.edu.ve') || isRussianEmail(email) ?
              <>
                {Math.floor((totalSize / (14 * 1024 * 1024 * 1024)) * 100) < 100 ?  
                  <Grid item xs={12} sm={6} xl={3}>
                    {urlimagen.length > 0 ?
                      <MiniStatisticsCard
                        title={{ text: "Archivo" }}
                        count="IMAGEN"
                        percentage={{ color: "success", text: "" }}
                        icon={{ color: "white", component: urlimagen }}
                      />
                    :
                      <MiniStatisticsCard
                        title={{ text: "Archivo" }}
                        count="IMAGEN"
                        percentage={{ color: "success", text: "" }}
                        icon={{ color: "white", component: "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/imagen.png" }}
                      />
                    }
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                      <CFormInput
                        size="sm"
                        type="text"
                        id="inputHtml"
                        placeholder="Subir link de Imagen"
                        value={urlimagen}
                        onChange={c => seturlimagen(c.target.value)}
                        style={{ flexGrow: 1 }}
                      />
                      {urlimagen ?
                        <Button
                          size="sm"
                          color="primary"
                          style={{ cursor: "pointer", marginLeft: '10px' }}
                          onClick={() => subirurl()}
                        >
                          Subir
                        </Button>
                      :
                        <Button
                          disabled
                          size="sm"
                          color="primary"
                          style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                        >
                          Subir
                        </Button>     
                      }
                    </div>
                  </Grid>
                :
                  <Grid item xs={12} sm={6} xl={3}>
                    {urlimagen.length > 0 ?
                      <MiniStatisticsCard
                        title={{ text: "Archivo" }}
                        count="IMAGEN"
                        percentage={{ color: "success", text: "" }}
                        icon={{ color: "white", component: urlimagen }}
                      />
                    :
                      <MiniStatisticsCard
                        title={{ text: "Archivo" }}
                        count="IMAGEN"
                        percentage={{ color: "success", text: "" }}
                        icon={{ color: "white", component: "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/imagen.png" }}
                      />
                    }
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                      <CFormInput
                        size="sm"
                        type="text"
                        id="inputHtml"
                        placeholder="Subir link de Imagen"
                        value={urlimagen}
                        onChange={c => seturlimagen(c.target.value)}
                        style={{ flexGrow: 1 }}
                      />
                      <Button
                        size="sm"
                        color="primary"
                        style={{ cursor: "pointer", marginLeft: '10px' }}
                        disabled
                      >
                        Subir
                      </Button>
                    </div>
                  </Grid>
                }
              </>
            :
              <>
                {base  ?
                  <>
                    {Math.floor((totalSize / (300 * 1024 * 1024 * 1024)) * 100) < 100 ?  
                      <Grid item xs={12} sm={6} xl={3}>
                        {urlimagen.length > 0 ?
                          <MiniStatisticsCard
                            title={{ text: "Archivo" }}
                            count="IMAGEN"
                            percentage={{ color: "success", text: "" }}
                            icon={{ color: "white", component: urlimagen }}
                          />
                        :
                          <MiniStatisticsCard
                            title={{ text: "Archivo" }}
                            count="IMAGEN"
                            percentage={{ color: "success", text: "" }}
                            icon={{ color: "white", component: "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/imagen.png" }}
                          />
                        }
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <CFormInput
                            size="sm"
                            type="text"
                            id="inputHtml"
                            placeholder="Subir link de Imagen"
                            value={urlimagen}
                            onChange={c => seturlimagen(c.target.value)}
                            style={{ flexGrow: 1 }}
                          />
                          {urlimagen ?
                            <Button
                              size="sm"
                              color="primary"
                              style={{ cursor: "pointer", marginLeft: '10px' }}
                              onClick={() => subirurl()}
                            >
                              Subir
                            </Button>
                          :
                            <Button
                              disabled
                              size="sm"
                              color="primary"
                              style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                            >
                              Subir
                            </Button>     
                          }
                        </div>
                      </Grid>
                    :
                      <Grid item xs={12} sm={6} xl={3}>
                        {urlimagen.length > 0 ?
                          <MiniStatisticsCard
                            title={{ text: "Archivo" }}
                            count="IMAGEN"
                            percentage={{ color: "success", text: "" }}
                            icon={{ color: "white", component: urlimagen }}
                          />
                        :
                          <MiniStatisticsCard
                            title={{ text: "Archivo" }}
                            count="IMAGEN"
                            percentage={{ color: "success", text: "" }}
                            icon={{ color: "white", component: "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/imagen.png" }}
                          />
                        }
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <CFormInput
                            size="sm"
                            type="text"
                            id="inputHtml"
                            placeholder="Subir link de Imagen"
                            value={urlimagen}
                            onChange={c => seturlimagen(c.target.value)}
                            style={{ flexGrow: 1 }}
                          />
                          <Button
                            size="sm"
                            color="primary"
                            style={{ cursor: "pointer", marginLeft: '10px' }}
                            disabled
                          >
                            Subir
                          </Button>
                        </div>
                      </Grid>
                    }
                  </>
                :
                  <>
                    {Math.floor((totalSize / (7 * 1024 * 1024 * 1024)) * 100) < 100 ?  
                      <Grid item xs={12} sm={6} xl={3}>
                        {urlimagen.length > 0 ?
                          <MiniStatisticsCard
                            title={{ text: "Archivo" }}
                            count="IMAGEN"
                            percentage={{ color: "success", text: "" }}
                            icon={{ color: "white", component: urlimagen }}
                          />
                        :
                          <MiniStatisticsCard
                            title={{ text: "Archivo" }}
                            count="IMAGEN"
                            percentage={{ color: "success", text: "" }}
                            icon={{ color: "white", component: "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/imagen.png" }}
                          />
                        }
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <CFormInput
                            size="sm"
                            type="text"
                            id="inputHtml"
                            placeholder="Subir link de Imagen"
                            value={urlimagen}
                            onChange={c => seturlimagen(c.target.value)}
                            style={{ flexGrow: 1 }}
                          />
                          {urlimagen ?
                            <Button
                              size="sm"
                              color="primary"
                              style={{ cursor: "pointer", marginLeft: '10px' }}
                              onClick={() => subirurl()}
                            >
                              Subir
                            </Button>
                          :
                            <Button
                              disabled
                              size="sm"
                              color="primary"
                              style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                            >
                              Subir
                            </Button>     
                          }
                        </div>
                      </Grid>
                    :
                      <Grid item xs={12} sm={6} xl={3}>
                        {urlimagen.length > 0 ?
                          <MiniStatisticsCard
                            title={{ text: "Archivo" }}
                            count="IMAGEN"
                            percentage={{ color: "success", text: "" }}
                            icon={{ color: "white", component: urlimagen }}
                          />
                        :
                          <MiniStatisticsCard
                            title={{ text: "Archivo" }}
                            count="IMAGEN"
                            percentage={{ color: "success", text: "" }}
                            icon={{ color: "white", component: "https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/imagen.png" }}
                          />
                        }
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <CFormInput
                            size="sm"
                            type="text"
                            id="inputHtml"
                            placeholder="Subir link de Imagen"
                            value={urlimagen}
                            onChange={c => seturlimagen(c.target.value)}
                            style={{ flexGrow: 1 }}
                          />
                          <Button
                            size="sm"
                            color="primary"
                            style={{ cursor: "pointer", marginLeft: '10px' }}
                            disabled
                          >
                            Subir
                          </Button>
                        </div>
                      </Grid>
                    }
                  </>
                }
              </>
            }


           </>
          )}



           {dato["Archivo(HTML)"] === true && (
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "Archivo" }}
                count="HTML"
                percentage={{ color: "success", text: "" }}
                icon={{ color: "white", component: "https://s3.amazonaws.com/www.codeflex.lat/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/HTML5_logo_and_wordmark.svg.png" }}
              />
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                <CFormInput
                  size="sm"
                  type="text"
                  id="inputHtml"
                  placeholder='index.html'
                  value={Html}
                  onChange={c => setHtml(c.target.value)}
                  style={{ flexGrow: 1 }}
                />

                {Html ?
                <Button
                  size="sm"
                  color="primary"
                  style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                  onClick={() => createHtmlFile2()}
                >
                  Crear
                </Button>
                :
                <Button
                  disabled
                  size="sm"
                  color="primary"
                  style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                >
                  Crear
                </Button>     
                }
              </div>
            </Grid>
            )}
            

            {dato["Archivo(CSS)"] === true && (
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard 
                title={{ text: "Archivo" }}
                count="CSS"
                percentage={{ color: "success", text: "" }}
                icon={{ color: "white", component: "https://s3.amazonaws.com/www.codeflex.lat/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/css.png" }}
              />
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                <CFormInput
                  size="sm"
                  type="text"
                  id="inputEmail4"
                  placeholder='style.css' 
                  value={Css} 
                  onChange={c => setCss(c.target.value)}
                  style={{ flexGrow: 1 }}
                />

                {Css ?
                <Button
                  size="sm"
                  color="primary"
                  style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                  onClick={() => createCssFile2()}
                >
                  Crear
                </Button>
                :
                <Button
                  disabled
                  size="sm"
                  color="primary"
                  style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                >
                  Crear
                </Button>     
                }

              </div>
            </Grid>
            )}

            {dato["Archivo(JS)"] === true && (
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard 
                title={{ text: "Archivo" }}
                count="JS"
                percentage={{ color: "success", text: "" }}
                icon={{ color: "white", component: "https://s3.amazonaws.com/www.codeflex.lat/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/js.png" }}
              />
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                <CFormInput
                  size="sm"
                  type="text"
                  id="inputEmail4" 
                  placeholder='app.js'  
                  value={Js}  
                  onChange={c => setJs(c.target.value)}
                  style={{ flexGrow: 1 }}
                />

                {Js ?
                <Button
                  size="sm"
                  color="primary"
                  style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                  onClick={() => createJsFile2()}
                >
                  Crear
                </Button>
                :
                <Button
                  disabled
                  size="sm"
                  color="primary"
                  style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                >
                  Crear
                </Button>     
                }

              </div>
            </Grid>
            )}

            {dato["Archivo(PYTHON)"] === true && (
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "Archivo" }}
                count="PYTHON"
                percentage={{ color: "success", text: "" }}
                icon={{
                  color: "white",
                  component: "https://s3.amazonaws.com/www.codeflex.lat/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/Python.png",
                }}
              />
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                <CFormInput
                  size="sm"
                  type="text"
                  id="inputEmail4" 
                  placeholder='clases.py'  
                  value={Py}  
                  onChange={c => setPy(c.target.value)}
                  style={{ flexGrow: 1 }}
                />

                {Py ?
                <Button
                  size="sm"
                  color="primary"
                  style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                  onClick={() => createpyFile2()}
                >
                  Crear
                </Button>
                :
                <Button
                  disabled
                  size="sm"
                  color="primary"
                  style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                >
                  Crear
                </Button>     
                }

              </div>
            </Grid>
            )}

            {dato["Archivo(TXT)"] === true && (
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "Archivo" }}
                count="TXT"
                percentage={{ color: "success", text: "" }}
                icon={{
                  color: "white",
                  component: "https://s3.amazonaws.com/www.codeflex.lat/documentos/c3320017-1937-4353-8881-475e3c89e25e/API/Img-Url-Date-26-05-2024-19-09.png.png",
                }}
              />
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                <CFormInput
                  size="sm"
                  type="text"
                  id="inputEmail4" 
                  placeholder='Documento.txt'  
                  value={Txt}  
                  onChange={c => setTxt(c.target.value)}
                  style={{ flexGrow: 1 }}
                />
                {Txt ?
                <Button
                    size="sm"
                    color="primary"
                    style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                    onClick={() => createtxtFile2()}
                  >
                    Crear
                </Button>
                :
                <Button
                  disabled
                  size="sm"
                  color="primary"
                  style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                >
                  Crear
                </Button>     
                }
              </div>
            </Grid>
            )}


            {dato["YouTube(MP4)"] === true && (
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "YouTube" }}
                count="MP4"
                percentage={{ color: "success", text: "" }}
                icon={{
                  color: "white",
                  component: "https://s3.amazonaws.com/www.codeflex.lat/documentos/c3320017-1937-4353-8881-475e3c89e25e/Python/22225.png",
                }}
              />
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                <CFormInput
                  size="sm"
                  type="text"
                  id="inputEmail4" 
                  placeholder='Subir link de YouTube'  
                  value={YouTubeMp4}  
                  onChange={c => setYouTubeMp4(c.target.value)}
                  style={{ flexGrow: 1 }}
                />

                {YouTubeMp4 ?
                <Button
                    size="sm"
                    color="primary"
                    style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                    onClick={() => createmp4File2()}
                  >
                    Subir
                </Button>
                :
                <Button
                  disabled
                  size="sm"
                  color="primary"
                  style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                >
                  Subir
                </Button>  
                }

              </div>
            </Grid>
            )}

            {dato["YouTube(MP3)"] === true && (
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "YouTube" }}
                count="MP3"
                percentage={{ color: "success", text: "" }}
                icon={{
                  color: "white",
                  component: "https://s3.amazonaws.com/www.codeflex.lat/documentos/76527625-b9dd-4efe-a987-6374f56e3d22/Navegador/Mp3.png",
                }}
              />
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                <CFormInput
                  size="sm"
                  type="text"
                  id="inputEmail4" 
                  placeholder='Subir link de YouTube'  
                  value={YouTubeMp3}  
                  onChange={c => setYouTubeMp3(c.target.value)}
                  style={{ flexGrow: 1 }}
                />

                {YouTubeMp3 ?
                <Button
                    size="sm"
                    color="primary"
                    style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                    onClick={() => createmp3File2()}
                  >
                    Subir
                </Button>
                :
                <Button
                  disabled
                  size="sm"
                  color="primary"
                  style={{ cursor: "pointer", marginLeft: '10px' }} // Add margin to separate the input and the button
                >
                  Subir
                </Button>  
                }

              </div>
            </Grid>
            )}

          </Grid>

          {dato["Mensaje"] && (
          <>
          <br/>
          <div style={{textAlign: "center"}}><p style={{fontSize:"13.5px", color:"tomato"}}>{dato["Mensaje"]}</p></div>
          </>
          )}
          </CCollapse>
          </>
          }
        </CCardBody>
        </CCard>
      </CCol>

    </SoftBox>

    <SoftBox py={3}>
    <CModal
      style={{
        position: 'fixed',
        width: '100%',
        height: '100%',
        background: 'rgba(255, 255, 255, 1)',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 9999,
      }}
    visible={visible2} onClose={() => setVisible2(false) + setInput("")} >
      <CModalHeader>
        <CModalTitle>¿Eliminar objetos permanentemente?</CModalTitle>
      </CModalHeader>
      <CModalBody style={{fontSize:"17px"}}>Para confirmar la eliminación, escriba eliminar de forma permanente en el campo de entrada de texto.<br/></CModalBody>
      <CModalFooter >
        <CFormInput type="text" size="sm" placeholder="eliminar de forma permanente" onChange={e => setInput(e.target.value)} aria-label="sm input example"/>
        <CButton color="light" onClick={() => setVisible2(false) + setInput("")}>Cerrar</CButton>
        {Input == "eliminar de forma permanente" ?
        <CButton color='warning'  onClick={eliminarArchivosSeleccionados} >Eliminar</CButton>
        :
        <CButton disabled color='warning'>Eliminar</CButton>
        }
      </CModalFooter>
    </CModal>


    <CModal
      style={{
        position: 'fixed',
        width: '100%',
        height: '100%',
        background: 'rgba(255, 255, 255, 1)',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 9999,
      }}
    visible={visible6} onClose={() => setVisible6(false) + setInput2("")} >
      <CModalHeader>
        <CModalTitle>Renombrar objeto?</CModalTitle>
      </CModalHeader>
      <CModalBody style={{fontSize:"17px"}}>Para renombrar, ingrese el nuevo nombre del objeto en el campo de texto. Asegúrese de que el nombre no contenga el carácter '/'.<br/></CModalBody>
      <CModalFooter >
        <CFormInput type="text" size="sm" placeholder="nuevo nombre del objeto" onChange={e => setInput2(e.target.value)} aria-label="sm input example"/>
        <CButton color="light" onClick={() => setVisible6(false) + setInput2("")}>Cerrar</CButton>
        {Input2.length > 0 ?
        <CButton color='warning'onClick={renombrar}>Renombrar</CButton>
        :
        <CButton disabled color='warning'>Renombrar</CButton>
        }
      </CModalFooter>
    </CModal>




    <CModal
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(255, 255, 255, 1)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        zIndex: 9999,
      }}
      fullscreen
      visible={visible4}
      onClose={() => setVisible4(false)}
      aria-labelledby="ScrollingLongContentExampleLabel2"
      id="modal-grande" 
    >
      <CModalHeader style={{ backgroundColor:"#343541", color: "#ffffff" }}>
        <CModalTitle>Terminal</CModalTitle>
      </CModalHeader>
      <CModalBody style={{ background: "black", color: "white", padding: 0 }}>
        <br/>
        <textarea
          style={{
            width: "100%",
            height: "100%",
            border: "none",  // Elimina el borde
            resize: "none",  // Deshabilita la redimensión
            outline: "none", // Elimina el resaltado del borde al enfocar
            fontFamily: "monospace", // Usa una fuente de espacio fijo
          }}
          id="areatex"
          readOnly // Para que el usuario no pueda editar el contenido
          value={resultados.map(line => `> ${line}`).join("\n")} // Agrega ">" antes de cada línea
        />
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={() => setVisible4(false)}>
          Cerrar
        </CButton>
      </CModalFooter>
    </CModal>
    <CToaster ref={toaster} push={toast} placement="top-end" />
    <CModal
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(255, 255, 255, 1)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        zIndex: 9999,
      }}
      fullscreen
          visible={visible}
          onClose={() => setVisible(false)}
        >
          <CModalHeader id='tas1'>
            <CModalTitle>CODEFLEX</CModalTitle>
          </CModalHeader>
          <CModalBody>

          <div className="page-loader" id="loader">
              <div className="loader">
                  <div className='loader-style-1 panelLoad'>
                      <div className='cube-face cube-face-front'>HTML</div>
                      <div className='cube-face cube-face-back'>CSS</div>
                      <div className='cube-face cube-face-left'>JS</div>
                      <div className='cube-face cube-face-right'>C#</div>
                      <div className='cube-face cube-face-bottom'>C++</div>
                      <div className='cube-face cube-face-top'>PY</div>
                  </div>
                  <span className="cube-face">Online</span>
              </div>
          </div>

          <CToaster style={{right: "20px", zIndex: 1050 }}>
            <CToast autohide={false} visible={visibletr}>
              <CToastHeader>
                <svg
                  className="rounded me-2"
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                  role="img"
                >
                  <rect width="100%" height="100%" fill="#007aff"></rect>
                </svg>
                <div className="fw-bold me-auto">&nbsp;&nbsp;Codeflex S.A.S.</div>
              </CToastHeader>
              <CToastBody>Archivo HTML/CSS/JS/PY guardado con éxito.</CToastBody>
            </CToast>
          </CToaster>
          {mostrar ?
          <Editor
            height="100%"
            theme="vs-dark" // Puedes cambiar el tema según tus preferencias
            language={editorLanguage} // Puedes cambiar el lenguaje según tus necesidades
            value={htmlContent}
            onChange={(value) => setHtmlContent(value)}
            options={{
              minimap: {
                enabled: true, // Puedes habilitar o deshabilitar el minimapa según tus preferencias
              },
            }}
          />
          :
          <></> 
          }
          </CModalBody>
          <CModalFooter>
            <div id='cargando3' style={{display:"none"}}>
              <strong style={{color:"#2980B9" , fontSize:"20px"}} role="status">Cargando...</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <CButton color="secondary" onClick={() => setVisible(false)}>
              Cerrar IDE
            </CButton>
            {viso.endsWith('.py') ? 
              <><CButton color="success" onClick={compilar}>Compilar (Ctrl + b)</CButton></>
              :
              <>
                {viso.endsWith('.txt')?
                  <></>
                :
                <><CButton color="success" onClick={visor}>Run (Ctrl + q)</CButton></>
                }
              </>
            } 
            <CButton color="primary" onClick={guardarHtml}>Guardar (Ctrl + s)</CButton>
          </CModalFooter>
        </CModal>

      <CModal 
        style={{
          position: 'fixed',
          width: '100%',
          height: '100%',
          background: 'rgba(255, 255, 255, 1)',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 9999,
        }}
      visible={visible3} onClose={() => setVisible3(false)}>
            <CModalHeader >
              <CModalTitle>Selecciona la extension</CModalTitle>
            </CModalHeader>
            <CModalBody >
             <span style={{fontSize:"17px"}}>Para confirmar la extencion, selecciónala en el campo de abajo.<br/></span>
              <CFormSelect 
                    size="sm" className="mb-3" aria-label="Small select example"
                    onChange={handleExtensionSelect}
                    >
                    <option value="">{extension3}</option>
                    <option value="pdf">pdf</option>
                    <option value="apk">apk</option>
                    <option value="txt">txt</option>
                    <option value="rar">rar</option>
                    <option value="mwb">mwb</option>
                    <option value="zip">zip</option>
                    <option value="docx">docx</option>
                    <option value="dotx">dotx</option>
                    <option value="doc">doc</option>
                    <option value="xls">xls</option>
                    <option value="xlsx">xlsx</option>
                    <option value="js">js</option>
                    <option value="json">json</option>
                    <option value="xlsb">xlsb</option>
                    <option value="xlsm">xlsm</option>
                    <option value="pptx">pptx</option>
                    <option value="pptm">pptm</option>
                    <option value="ppt">ppt</option>
                    <option value="mdb">mdb</option>
                    <option value="accdb">accdb</option>
                    <option value="pubmhtml">pubmhtml</option>
                    <option value="pub">pub</option>
                    <option value="vsdm">vsdm</option>
                    <option value="vsdx">vsdx</option>
                    <option value="vssx">vssx</option>
                    <option value="wav">wav</option>
                    <option value="aiff">aiff</option>
                    <option value="flac">flac</option>
                    <option value="mp3">mp3</option>
                    <option value="ogg">ogg</option>
                    <option value="mp4">mp4</option>
                    <option value="mkv">mkv</option>
                    <option value="avi">avi</option>
                    <option value="mpg">mpg</option>
                    <option value="flv">flv</option>
                    <option value="jpg">jpg</option>
                    <option value="jpeg">jpeg</option>
                    <option value="gif">gif</option>
                    <option value="png">png</option>
                    <option value="tiff">tiff</option>
                    <option value="svg">svg</option>
                    <option value="psd">psd</option>
                    <option value="eps">eps</option>
                    <option value="ai">ai</option>
                    <option value="msi">msi</option>
                    <option value="iso">iso</option>
              </CFormSelect>
              <center>
                <CButton color="dark" shape="rounded-pill" variant="outline"  size="sm" onClick={() => setExtension("") + setExtension2("") + setExtension3("Todos los archivos") + setVisible3(false)}>
                  Todos los archivos
                </CButton>
              </center>
            </CModalBody>
        </CModal>


        <CModal 
        style={{
          position: 'fixed',
          width: '100%',
          height: '100%',
          background: 'rgba(255, 255, 255, 1)',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 9999,
        }}
      visible={visible5} onClose={() => setVisible5(false)}>
            <CModalHeader >
              <CModalTitle>Nombre de la carpeta</CModalTitle>
            </CModalHeader>
            <CModalBody>
            <CFormInput size="sm" type="text" id="input" placeholder='Ingresa el nombre de la carpeta'  value={namecarpeta}  onChange={c => setnamecarpeta(c.target.value)} />
             <span style={{fontSize:"17px"}}>Los nombres de las carpetas no pueden contener “/”<br/></span>
              <center>
                <CButton color="info" shape="rounded-pill"  size="sm" onClick={() => crearcarpeta()}>
                  Crear Carpeta
                </CButton>
              </center>
            </CModalBody>
        </CModal>

        <CCol mb={3}>
          <CCard className="mb-4">
            <CCardHeader>
              <SoftTypography variant="h6">/{carpe}</SoftTypography>
            </CCardHeader>
            <CCardBody>

            {subiendo ?   
              <></>
              :
              <>
               <div className=" justify-content-between mb-4">
                <CButton color="dark" shape="rounded-pill" variant="outline"  size="sm" onClick={() => refrescar()}>
                  <CIcon  icon={cilReload}  />
                </CButton> &nbsp;
                {checkbox ?
                  <CButton color="warning" shape="rounded-0" size="sm" className="mx-2" onClick={() => modal2()} >
                    Eliminar: ({archivosSeleccionados.length})
                  </CButton>
                  :
                  <CButton color="warning" disabled shape="rounded-0" size="sm" className="mx-2" >
                    Eliminar
                  </CButton>
                }&nbsp;

                {checkbox ?
                  <CButton color="info" shape="rounded-0" size="sm" className="mx-2" onClick={descargar}>
                    Descargar: ({archivosSeleccionados.length})
                  </CButton>
                  :
                  <CButton color="info" disabled shape="rounded-0" size="sm" className="mx-2" >
                    Descargar
                  </CButton>
                }&nbsp;

                {(checkbox && archivosSeleccionados.length == 1 && !archivosSeleccionados[0].endsWith('/')) ?
                  <CButton color="dark" shape="rounded-0" size="sm" className="mx-2" onClick={() => modal3()}>
                    Renombrar
                  </CButton>
                  :
                  <CButton color="dark" shape="rounded-0" variant="outline" size="sm" className="mx-2" disabled>
                    Renombrar
                  </CButton>
                } &nbsp;

                {currentFolder.length > 0 && (
                <CButton color="dark" shape="rounded-0" size="sm"  className="mx-2"  onClick={volverACarpetaPrincipal}>
                  Volver a la carpeta anterior
                </CButton>
                )}&nbsp;



                {email.endsWith('.edu') ||  email.endsWith('.una.ac.cr') ||  email.endsWith('.edu.co') || email.endsWith('.edu.ar') || email.endsWith('.edu.mx') ||  email.endsWith('.edu.es') || email.endsWith('.edu.br') || email.endsWith('.edu.ve') || isRussianEmail(email) ?
                  <>
                    {Math.floor((totalSize / (14 * 1024 * 1024 * 1024)) * 100) < 100 ?   
                      <>  
                        <CButton color="light" shape="rounded-0" size="sm" className="mx-2" onClick={abrirSelectorDeArchivos}>
                          Agregar carpeta
                        </CButton>
                        <input
                          key={inputKey2}
                          ref={fileInputRef}
                          style={{ display: 'none' }}
                          type="file"
                          id="formFileSm"
                          onChange={(e) => {change3(e);}}
                          directory=""
                          webkitdirectory=""
                          accept="/*"
                        />
                      </>   
                    :
                      <> 
                        <CButton color="light" shape="rounded-0" size="sm" className="mx-2" disabled>
                          Agregar carpeta
                        </CButton>
                      </>
                    }
                  </>
                :
                  <>
                    {base  ?
                      <>
                        {Math.floor((totalSize / (300 * 1024 * 1024 * 1024)) * 100) < 100 ?   
                          <>  
                            <CButton color="light" shape="rounded-0" size="sm" className="mx-2" onClick={abrirSelectorDeArchivos}>
                              Agregar carpeta
                            </CButton>
                            <input
                              key={inputKey2}
                              ref={fileInputRef}
                              style={{ display: 'none' }}
                              type="file"
                              id="formFileSm"
                              onChange={(e) => {change3(e);}}
                              directory=""
                              webkitdirectory=""
                              accept="/*"
                            />
                          </>   
                        :
                          <> 
                            <CButton color="light" shape="rounded-0" size="sm" className="mx-2" disabled>
                              Agregar carpeta
                            </CButton>
                          </>
                        }
                      </>
                    :
                      <>
                        {Math.floor((totalSize / (7 * 1024 * 1024 * 1024)) * 100) < 100 ?   
                          <>  
                            <CButton color="light" shape="rounded-0" size="sm" className="mx-2" onClick={abrirSelectorDeArchivos}>
                              Agregar carpeta
                            </CButton>
                            <input
                              key={inputKey2}
                              ref={fileInputRef}
                              style={{ display: 'none' }}
                              type="file"
                              id="formFileSm"
                              onChange={(e) => {change3(e);}}
                              directory=""
                              webkitdirectory=""
                              accept="/*"
                            />
                          </>   
                        :
                          <> 
                            <CButton color="light" shape="rounded-0" size="sm" className="mx-2" disabled>
                              Agregar carpeta
                            </CButton>
                          </>
                        }
                      </>
                    }
                  </>
                }&nbsp;




                {email.endsWith('.edu') ||  email.endsWith('.una.ac.cr') ||  email.endsWith('.edu.co') || email.endsWith('.edu.ar') || email.endsWith('.edu.mx') ||  email.endsWith('.edu.es') || email.endsWith('.edu.br') || email.endsWith('.edu.ve') || isRussianEmail(email) ?
                  <>
                    {Math.floor((totalSize / (14 * 1024 * 1024 * 1024)) * 100) < 100 ?   
                      <>  
                        <CButton color="light" shape="rounded-0" size="sm" className="mx-2" onClick={abrirSelectorDeArchivos2}>
                          Agregar archivos
                        </CButton>
                        <input
                          key={inputKey}
                          ref={fileInputRef2}
                          style={{ display: 'none' }}
                          type="file"
                          id="formFileSm"
                          onChange={(e) => {change(e);}}
                          accept="/*" 
                          multiple
                        />
                      </>   
                    :
                      <> 
                        <CButton color="light" shape="rounded-0" size="sm" className="mx-2" disabled>
                          Agregar archivos
                        </CButton>
                      </>
                    }
                  </>   
                :
                  <>
                    {base  ?
                      <>
                        {Math.floor((totalSize / (300 * 1024 * 1024 * 1024)) * 100) < 100 ?   
                          <>  
                            <CButton color="light" shape="rounded-0" size="sm" className="mx-2" onClick={abrirSelectorDeArchivos2}>
                              Agregar archivos
                            </CButton>
                            <input
                              key={inputKey}
                              ref={fileInputRef2}
                              style={{ display: 'none' }}
                              type="file"
                              id="formFileSm"
                              onChange={(e) => {change(e);}}
                              accept="/*" 
                              multiple
                            />
                          </>   
                        :
                          <> 
                            <CButton color="light" shape="rounded-0" size="sm" className="mx-2" disabled>
                              Agregar archivos
                            </CButton>
                          </>
                        }
                      </>   
                    :
                      <>
                        {Math.floor((totalSize / (7 * 1024 * 1024 * 1024)) * 100) < 100 ?   
                          <>  
                            <CButton color="light" shape="rounded-0" size="sm" className="mx-2" onClick={abrirSelectorDeArchivos2}>
                              Agregar archivos
                            </CButton>
                            <input
                              key={inputKey}
                              ref={fileInputRef2}
                              style={{ display: 'none' }}
                              type="file"
                              id="formFileSm"
                              onChange={(e) => {change(e);}}
                              accept="/*" 
                              multiple
                            />
                          </>   
                        :
                          <> 
                            <CButton color="light" shape="rounded-0" size="sm" className="mx-2" disabled>
                              Agregar archivos
                            </CButton>
                          </>
                        }
                      </>
                    }
                  </>
                }&nbsp;
                <CButton color="light" shape="rounded-0" size="sm" className="mx-2" onClick={modalcarpeta}>
                  Crear carpeta
                </CButton><br/><br/>
            </div></>
              }

            <SoftTypography variant="h6">Objetos en carpeta ({datos.length})</SoftTypography>
            <div className="d-flex align-items-center">
                <CFormInput
                  type="text"
                  size="sm"
                  placeholder="Search"
                  aria-label="sm input example"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
            </div><br/>


            {email.endsWith('.edu') ||  email.endsWith('.una.ac.cr') ||  email.endsWith('.edu.co') || email.endsWith('.edu.ar') || email.endsWith('.edu.mx') ||  email.endsWith('.edu.es') || email.endsWith('.edu.br') || email.endsWith('.edu.ve') || isRussianEmail(email) ?
              <>
                {Math.floor((totalSize / (14 * 1024 * 1024 * 1024)) * 100) < 100 ?   
                  <>  
                    {showDropArea && (
                      <div
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        style={{
                          position: 'fixed',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          background: 'rgba(255, 255, 255, 1)',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          zIndex: 9999,
                          border: '4px dashed gray', // Estilo del borde punteado de color gris
                        }}
                      >
                        <div>
                          Coloque los archivos y las carpetas que desee cargar aquí.
                        </div>
                      </div>
                    )}
                    <div
                      style={{
                        border: '2px dashed gray',
                        padding: '10px',
                        textAlign: 'center',
                      }}
                    >
                      <div>
                        <p style={{fontSize:"18px"}}>Arrastre y suelte aquí los archivos y carpetas que desee cargar.</p>
                      </div>
                    </div>
                  </>   
                :
                  <> 
                    <div
                      style={{
                        border: '2px dashed gray',
                        padding: '10px',
                        textAlign: 'center',
                      }}
                    >
                      <div style={{fontSize:"18px"}}>
                        Almacenamiento lleno. <br/>
                        {Math.floor((totalSize / (14 * 1024 * 1024 * 1024)) * 100)}% lleno, con {formatBytes(totalSize)} de 14GB en uso.
                      </div>
                    </div>
                  </>
                }
              </>
            :
              <>
                {base  ?
                  <>
                    {Math.floor((totalSize / (300 * 1024 * 1024 * 1024)) * 100) < 100 ?   
                      <>  
                        {showDropArea && (
                          <div
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                            style={{
                              position: 'fixed',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              background: 'rgba(255, 255, 255, 1)',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'center',
                              zIndex: 9999,
                              border: '4px dashed gray', // Estilo del borde punteado de color gris
                            }}
                          >
                            <div>
                              Coloque los archivos y las carpetas que desee cargar aquí.
                            </div>
                          </div>
                        )}
                        <div
                          style={{
                            border: '2px dashed gray',
                            padding: '10px',
                            textAlign: 'center',
                          }}
                        >
                          <div>
                            <p style={{fontSize:"18px"}}>Arrastre y suelte aquí los archivos y carpetas que desee cargar.</p>
                          </div>
                        </div>
                      </>   
                    :
                      <> 
                        <div
                          style={{
                            border: '2px dashed gray',
                            padding: '10px',
                            textAlign: 'center',
                          }}
                        >
                          <div style={{fontSize:"18px"}}>
                            Almacenamiento lleno. <br/>
                            {Math.floor((totalSize / (300 * 1024 * 1024 * 1024)) * 100)}% lleno, con {formatBytes(totalSize)} de 300GB en uso.
                          </div>
                        </div>
                      </>
                    }
                  </>
                :
                  <>
                    {Math.floor((totalSize / (7 * 1024 * 1024 * 1024)) * 100) < 100 ?   
                      <>  
                        {showDropArea && (
                          <div
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                            style={{
                              position: 'fixed',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              background: 'rgba(255, 255, 255, 1)',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'center',
                              zIndex: 9999,
                              border: '4px dashed gray', // Estilo del borde punteado de color gris
                            }}
                          >
                            <div>
                              Coloque los archivos y las carpetas que desee cargar aquí.
                            </div>
                          </div>
                        )}
                        <div
                          style={{
                            border: '2px dashed gray',
                            padding: '10px',
                            textAlign: 'center',
                          }}
                        >
                          <div>
                            <p style={{fontSize:"18px"}}>Arrastre y suelte aquí los archivos y carpetas que desee cargar.</p>
                          </div>
                        </div>
                      </>   
                    :
                      <> 
                        <div
                          style={{
                            border: '2px dashed gray',
                            padding: '10px',
                            textAlign: 'center',
                          }}
                        >
                          <div style={{fontSize:"18px"}}>
                            Almacenamiento lleno. <br/>
                            {Math.floor((totalSize / (7 * 1024 * 1024 * 1024)) * 100)}% lleno, con {formatBytes(totalSize)} de 7GB en uso.
                          </div>
                        </div>
                      </>
                    }
                  </>
                }
              </>
            }


          <br/>
          {Activado ?
            <CTable responsive  bordered small className="elegant-table">
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell scope="col">Nombre</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Progreso </CTableHeaderCell>
                  <CTableHeaderCell scope="col">Porcentaje</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Tiempo restante estimado</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Cancelar</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
                
              {datos2.map((result, index) => (
                <CTableBody key={index}>
                  {result.progress < 100 && (
                  <CTableRow>
                    <CTableDataCell>{result.name}</CTableDataCell>
                    <CTableDataCell>
                    <CProgress className="mb-3" >
                      {result.progress < 33 && (
                      <CProgressBar color="danger" variant="striped" value={result.progress} animated={true}/>
                      )}
                      {result.progress >= 33 && result.progress < 66 && (
                      <CProgressBar color="warning" variant="striped" value={result.progress} animated={true}/>
                      )}
                      {result.progress >= 66 && (
                      <CProgressBar color="success" variant="striped" value={result.progress} animated={true}/>
                      )}
                    </CProgress> 
                    </CTableDataCell>
                    <CTableDataCell><center>{result.progress}%</center></CTableDataCell>
                    <CTableDataCell><center>{result.progress > 0 ? formatTime(result.tiempo) : "-"}</center></CTableDataCell>
                    <CTableDataCell><CButton color="danger" variant="outline" className="me-md-2" onClick={() => cancelUpload(result.name) + setbtn(true)}>Cancelar</CButton></CTableDataCell>
                  </CTableRow>
                  )}
                </CTableBody>
              ))}
            </CTable>
            : 
            <>
            <div className="table-responsive-wrapper" style={{ overflow: 'auto', height: 'calc(100vh - 210px)', display: 'block', position: 'relative' }}>

            {datos.length ?
            <>


              <CTable bordered id="proyectos-table" small className="elegant-table" style={{minWidth: "1100px"}}>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell scope="col">
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col">Nombre</CTableHeaderCell>

                    <CTableHeaderCell scope="col">
                      Tipo <span><CIcon icon={cilCaretBottom} style={{cursor:"pointer"}} onClick={() => ModalTipo()}/></span>
                    </CTableHeaderCell>

                    <CTableHeaderCell scope="col">
                      Modificación <span><CIcon icon={cilCaretBottom} style={{cursor:"pointer"}} onClick={() => handleSort('fecha')}/></span>
                    </CTableHeaderCell>

                    <CTableHeaderCell scope="col">
                      Tamaño <span><CIcon icon={cilCaretBottom} style={{cursor:"pointer"}} onClick={() => handleSort('tamano')}/></span>
                    </CTableHeaderCell>

                    <CTableHeaderCell scope="col">Vista</CTableHeaderCell>
                    <CTableHeaderCell scope="col">Url</CTableHeaderCell>
                    <CTableHeaderCell scope="col">Url Corta</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>

                {sortData(datos).map((result, index) => 
                (extension === "" || result.extencion === extension) && 
                (searchInput === "" || result.nombre.toLowerCase().includes(searchInput.toLowerCase())) &&( 
                <CTableBody key={index}>
                  <CTableRow className={`row-hover ${archivosSeleccionados.includes(result.path) ? 'row-selected' : ''}`} > 
                    <CTableHeaderCell scope="row" className="td2" style={{verticalAlign: 'middle'}}>
                    <center>
                      <CFormCheck id={`check-${index+1}`} value={result.path}  onChange={(event) => selected(event, result.path) + identificar()}  checked={archivosSeleccionados.includes(result.path)} type="checkbox" aria-label="..."/>
                    </center>
                    </CTableHeaderCell>
                    <CTableDataCell className="td2">{result.nombre}</CTableDataCell>
                    <CTableDataCell className="td2">.{result.extencion}&nbsp;
                    {result.extencion === "carpeta"  ?
                      <>
                        <img src="https://s3.amazonaws.com/drive.primerosauxilios.online/documentos/9720c313-30fe-46d5-948b-52c89d0f3ad0/carpeta.png" width={23} />&nbsp;&nbsp;&nbsp;
                      </>
                      :
                      <>
                         <img src={result.logo} width={23} />&nbsp;&nbsp;&nbsp;
                      </>
                    }  
                    </CTableDataCell>
                    <CTableDataCell className="td2">{result.fecha}</CTableDataCell>
                    <CTableDataCell className="td2">{result.tamano}&nbsp;&nbsp;&nbsp;</CTableDataCell>
                    <CTableDataCell className="td2">
                    {result.path.endsWith('pdf') ?
                      <>
                      <CButton color="info" variant="outline" onClick={() => Verpdf(result.path)}>Abrir</CButton> 
                      </>
                      :
                      <>
                      {result.path.endsWith('docx') || result.path.endsWith('docm') || result.path.endsWith('dotx') || result.path.endsWith('dotm') || result.path.endsWith('doc') || result.path.endsWith('dot') || result.path.endsWith('xls') || result.path.endsWith('xlsx') || result.path.endsWith('xlsm') || result.path.endsWith('xlsb') || result.path.endsWith('xltm') || result.path.endsWith('xlam') || result.path.endsWith('xlr') || result.path.endsWith('xlw') || result.path.endsWith('xltx') || result.path.endsWith('xlt') || result.path.endsWith('pptx') || result.path.endsWith('pptm') || result.path.endsWith('ppt') || result.path.endsWith('ppam') || result.path.endsWith('potx') || result.path.endsWith('potm') || result.path.endsWith('pot') || result.path.endsWith('ppsx') || result.path.endsWith('ppsm') || result.path.endsWith('pps') || result.path.endsWith('Ppa') ?
                      <>
                      <CButton color="info" variant="outline" onClick={() => Verdoc(result.path)}>Abrir</CButton> 
                      </>
                      :
                      <>
                      {result.extencion === "json" || result.extencion === "js" || result.extencion === "carpeta" || result.extencion === "txt" || result.extencion === "wav" || result.extencion === "aiff" || result.extencion === "dsd" || result.extencion === "bwf" || result.extencion === "flac" || result.extencion === "ape" || result.extencion === "mp3" || result.extencion === "css" || result.extencion === "ogg" || result.extencion === "mka" || result.extencion === "wma" || result.extencion === "oga" || result.extencion === "mp4" || result.extencion === "mkv" || result.extencion === "asf" || result.extencion === "avi" || result.extencion === "mpg" || result.extencion === "flv" || result.extencion === "PNG" || result.extencion === "wmv" || result.extencion === "vob" || result.extencion === "jpg" || result.extencion === "jpeg" || result.extencion === "gif" || result.extencion === "png" || result.extencion === "tiff" || result.extencion === "tif" || result.extencion === "webp" || result.extencion === "raw" || result.extencion === "html" || result.extencion === "py"  || result.extencion === "svg" || result.extencion === "jfif" ?
                      <>

                        {result.extencion === "carpeta"  ?
                        <>
                          <CButton color="info" variant="outline" onClick={() => abrirCarpeta(result.nombre)}>Abrir</CButton> 
                        </>
                        :
                        <>
                          <CButton color="info" variant="outline" onClick={() => Ver(result.path)}>Abrir</CButton> 
                        </>
                        }  
                      </>
                      :
                      <>
                        <CButton color="dark" variant="outline" onClick={() => Ver(result.path)}>Bajar</CButton> 
                      </>
                      }   
                      {result.path.endsWith('html') || result.path.endsWith('css') || result.path.endsWith('js') || result.path.endsWith('py') || result.path.endsWith('txt')  ?
                      <>
                       &nbsp;<CButton color="warning" variant="outline" onClick={() => abrirhtml(result.path)}><CIcon icon={cilPen} size="lg" style={{ marginRight: '3px' }} /></CButton> 
                      </>
                      :
                      <>

                      {result.path.endsWith('json')?
                      <>
                       &nbsp;<CButton color="danger" variant="outline" onClick={() => etiqueta(result.path)} ><CIcon icon={cilLockUnlocked} size="lg" style={{ marginRight: '3px' }} /></CButton> 
                      </>
                      :
                      <>

                      {result.extencion === "carpeta"?
                      <>
                       &nbsp;<CButton color="danger" variant="outline"  onClick={() => fipuc(result.path)} ><CIcon icon={cibMixcloud} size="lg" style={{ marginRight: '3px' }} /></CButton> 
                      </>
                      :
                      <>

                      </>
                      } 

                      </>
                      } 

                      </>
                      }   
                      </> 
                      }
                      </>
                    }
                    </CTableDataCell>
                    <CTableDataCell className="td2">
                    {result.extencion === "carpeta"  ?
                      <>
                         
                      </>
                      :
                      <>
                          <center>
                            <CButton color="success" variant="outline" onClick={() => copiar2(result.path,result.nombre)}>Url</CButton>
                          </center>
                      </>
                    }
                      </CTableDataCell>
                    <CTableDataCell className="td2">
                    {result.extencion === "carpeta"  ?
                      <>
                        
                      </>
                      :
                      <>
                          <center>
                            <CButton color="primary" variant="outline" onClick={() => copiar(result.path,result.nombre)}>Short URL</CButton>
                          </center>
                      </>
                    }
                    </CTableDataCell>
                  </CTableRow>
                </CTableBody>
                ))} 
              </CTable>
              </>
              :
              <center><div style={{fontSize:"16px", backgroundColor:"#f8fafc", padding:"40px 20px"}}>
                {cargandoTabla ? (
                  <div style={{display:"flex", flexDirection:"column", alignItems:"center", gap:"12px"}}>
                    <div className="spinner-border text-primary" role="status" style={{width:"36px", height:"36px"}}></div>
                    <span style={{color:"#64748b"}}>Cargando archivos...</span>
                  </div>
                ) : (
                  <span style={{color:"#94a3b8"}}>No hay archivos en esta carpeta</span>
                )}
              </div></center>
              }
              </div>
            </>
            }
          </CCardBody>
        </CCard>
      </CCol>
      </SoftBox>
      </>
        :
        <>
        </>
      }

      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
